var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __knownSymbol = (name, symbol) => (symbol = Symbol[name]) ? symbol : /* @__PURE__ */ Symbol.for("Symbol." + name);
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
var __await = function(promise, isYieldStar) {
  this[0] = promise;
  this[1] = isYieldStar;
};
var __asyncGenerator = (__this, __arguments, generator) => {
  var resume = (k, v, yes, no) => {
    try {
      var x = generator[k](v), isAwait = (v = x.value) instanceof __await, done = x.done;
      Promise.resolve(isAwait ? v[0] : v).then((y) => isAwait ? resume(k === "return" ? k : "next", v[1] ? { done: y.done, value: y.value } : y, yes, no) : yes({ value: y, done })).catch((e) => resume("throw", e, yes, no));
    } catch (e) {
      no(e);
    }
  }, method = (k) => it[k] = (x) => new Promise((yes, no) => resume(k, x, yes, no)), it = {};
  return generator = generator.apply(__this, __arguments), it[__knownSymbol("asyncIterator")] = () => it, method("next"), method("throw"), method("return"), it;
};
var __forAwait = (obj, it, method) => (it = obj[__knownSymbol("asyncIterator")]) ? it.call(obj) : (obj = obj[__knownSymbol("iterator")](), it = {}, method = (key, fn) => (fn = obj[key]) && (it[key] = (arg) => new Promise((yes, no, done) => (arg = fn.call(obj, arg), done = arg.done, Promise.resolve(arg.value).then((value) => yes({ value, done }), no)))), method("next"), method("return"), it);

// src/midi-notes.ts
var NOTE_NAMES = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"];
var NOTE_OFFSETS = {
  C: 0,
  "C#": 1,
  Db: 1,
  D: 2,
  "D#": 3,
  Eb: 3,
  E: 4,
  F: 5,
  "F#": 6,
  Gb: 6,
  G: 7,
  "G#": 8,
  Ab: 8,
  A: 9,
  "A#": 10,
  Bb: 10,
  B: 11
};
function midiNoteToName(note) {
  const octave = Math.floor(note / 12) - 1;
  const noteName = NOTE_NAMES[note % 12];
  return `${noteName}${octave}`;
}
function parseMidiNote(noteOrNumber) {
  if (typeof noteOrNumber === "number") {
    if (noteOrNumber < 0 || noteOrNumber > 127 || !Number.isInteger(noteOrNumber)) {
      throw new Error(`MIDI note number out of range: ${noteOrNumber}`);
    }
    return noteOrNumber;
  }
  const match = noteOrNumber.match(/^([A-Ga-g])([#b]?)(-?\d)$/);
  if (!match) {
    throw new Error(`Invalid note name: "${noteOrNumber}"`);
  }
  const letter = match[1].toUpperCase();
  const accidental = match[2];
  const octave = parseInt(match[3], 10);
  const baseName = letter + (accidental != null ? accidental : "");
  const semitone = NOTE_OFFSETS[baseName];
  if (semitone === void 0) {
    throw new Error(`Invalid note name: "${noteOrNumber}"`);
  }
  const midiNote = (octave + 1) * 12 + semitone;
  if (midiNote < 0 || midiNote > 127) {
    throw new Error(
      `MIDI note "${noteOrNumber}" resolves to ${midiNote}, which is out of range (0-127)`
    );
  }
  return midiNote;
}
function resolveKey(key) {
  return parseMidiNote(key);
}

// src/schemas/common-schema.ts
import { z } from "zod";
var DeviceTypeSchema = z.enum(["s330", "s550", "jv1080", "d110"]);
var LoopModeSchema = z.enum(["oneShot", "forward", "alternating", "reverse"]);
var BaseWaveParamsSchema = z.object({
  /** Filename of the associated WAV file */
  file: z.string().min(1),
  /** Sample rate in Hz */
  sampleRate: z.number().int().positive(),
  /** Loop playback mode */
  loopMode: LoopModeSchema,
  /** Start point — where playback begins (sample offset, default 0) */
  startPoint: z.number().int().min(0).optional(),
  /** End point — where playback stops (sample offset). In loop modes, playback jumps to loopPoint after reaching endPoint. */
  endPoint: z.number().int().min(0).optional(),
  /** Loop point — where playback jumps to after reaching endPoint in loop modes (sample offset) */
  loopPoint: z.number().int().min(0).optional()
});
var S330EnvelopeSchema = z.object({
  /** 8 level values (0-127) */
  levels: z.tuple([
    z.number().int().min(0).max(127),
    z.number().int().min(0).max(127),
    z.number().int().min(0).max(127),
    z.number().int().min(0).max(127),
    z.number().int().min(0).max(127),
    z.number().int().min(0).max(127),
    z.number().int().min(0).max(127),
    z.number().int().min(0).max(127)
  ]),
  /** 8 rate values (1-127) */
  rates: z.tuple([
    z.number().int().min(1).max(127),
    z.number().int().min(1).max(127),
    z.number().int().min(1).max(127),
    z.number().int().min(1).max(127),
    z.number().int().min(1).max(127),
    z.number().int().min(1).max(127),
    z.number().int().min(1).max(127),
    z.number().int().min(1).max(127)
  ]),
  /** Sustain point (0-7) */
  sustainPoint: z.number().int().min(0).max(7),
  /** End point (1-8) */
  endPoint: z.number().int().min(1).max(8)
});
var AdsrEnvelopeSchema = z.object({
  attack: z.number().int().min(0).max(127),
  decay: z.number().int().min(0).max(127),
  sustain: z.number().int().min(0).max(127),
  release: z.number().int().min(0).max(127)
});
var MidiNoteNameSchema = z.string().regex(
  /^[A-Ga-g][#b]?-?[0-9]$/,
  "Must be a valid MIDI note name (e.g., C2, F#4, Bb3)"
);
var MidiNoteSchema = z.union([
  MidiNoteNameSchema,
  z.number().int().min(0).max(127)
]);
var VelocityRangeSchema = z.tuple([
  z.number().int().min(1).max(127),
  z.number().int().min(1).max(127)
]).refine(
  ([min, max]) => min <= max,
  { message: "Velocity range min must be <= max" }
);
var KeyRangeSchema = z.tuple([
  z.number().int().min(0).max(127),
  z.number().int().min(0).max(127)
]).refine(
  ([low, high]) => low <= high,
  { message: "Key range low must be <= high" }
);

// src/schemas/tone-schema.ts
import { z as z2 } from "zod";
var S330LfoParamsSchema = z2.object({
  /** LFO rate/speed (0-127) */
  rate: z2.number().int().min(0).max(127),
  /** Key sync on/off */
  sync: z2.boolean(),
  /** LFO delay time (0-127) */
  delay: z2.number().int().min(0).max(127),
  /** LFO mode */
  mode: z2.enum(["normal", "one-shot"]),
  /** LFO polarity */
  polarity: z2.boolean().optional(),
  /** LFO offset (0-127) */
  offset: z2.number().int().min(0).max(127).optional()
});
var S330TvfParamsSchema = z2.object({
  /** Filter cutoff frequency (0-127) */
  cutoff: z2.number().int().min(0).max(127),
  /** Filter resonance (0-127) */
  resonance: z2.number().int().min(0).max(127),
  /** Keyboard follow for filter (0-127) */
  keyFollow: z2.number().int().min(0).max(127),
  /** LFO modulation depth (0-127) */
  lfoDepth: z2.number().int().min(0).max(127).optional(),
  /** Envelope depth (0-127) */
  egDepth: z2.number().int().min(0).max(127),
  /** Envelope polarity */
  egPolarity: z2.enum(["normal", "reverse"]),
  /** Level curve (0-5) */
  levelCurve: z2.number().int().min(0).max(5).optional(),
  /** Key rate follow (0-127) */
  keyRateFollow: z2.number().int().min(0).max(127).optional(),
  /** Velocity rate follow (0-127) */
  velRateFollow: z2.number().int().min(0).max(127).optional(),
  /** Filter on/off */
  enabled: z2.boolean(),
  /** 8-point envelope */
  envelope: S330EnvelopeSchema.optional()
});
var S330TvaParamsSchema = z2.object({
  /** Output level (0-127) */
  level: z2.number().int().min(0).max(127),
  /** LFO modulation depth (0-127) */
  lfoDepth: z2.number().int().min(0).max(127).optional(),
  /** Keyboard rate follow (0-127) */
  keyRate: z2.number().int().min(0).max(127).optional(),
  /** Velocity rate follow (0-127) */
  velRate: z2.number().int().min(0).max(127).optional(),
  /** Level curve (0-5) */
  levelCurve: z2.number().int().min(0).max(5).optional(),
  /** 8-point envelope */
  envelope: S330EnvelopeSchema
});
function createSeriesToneExtensionSchema(maxSourceTone) {
  return z2.object({
    originalKey: z2.number().int().min(11).max(108),
    outputAssign: z2.number().int().min(0).max(7),
    sourceTone: z2.number().int().min(0).max(maxSourceTone).optional(),
    transpose: z2.number().int().min(-64).max(63).default(0),
    fineTune: z2.number().int().min(-64).max(63).default(0),
    lfo: S330LfoParamsSchema.optional(),
    tvf: S330TvfParamsSchema.optional(),
    tva: S330TvaParamsSchema.optional(),
    benderEnabled: z2.boolean().optional(),
    aftertouchEnabled: z2.boolean().optional(),
    pitchFollow: z2.boolean().optional()
  });
}
var S330ToneExtensionSchema = createSeriesToneExtensionSchema(31);
var S550ToneExtensionSchema = createSeriesToneExtensionSchema(63);
var ToneYamlSchema = z2.object({
  /** Format identifier */
  format: z2.literal("sampler-tone"),
  /** Device type */
  device: DeviceTypeSchema,
  /** Schema version */
  version: z2.number().int().positive(),
  /** Tone name */
  name: z2.string().min(1).max(12),
  /** Wave parameters */
  wave: BaseWaveParamsSchema,
  /** S-330 specific parameters */
  s330: S330ToneExtensionSchema.optional(),
  /** S-550 specific parameters */
  s550: S550ToneExtensionSchema.optional()
  // Future device extensions:
  // jv1080: JV1080ToneExtensionSchema.optional(),
  // d110: D110ToneExtensionSchema.optional(),
}).refine(
  (data) => {
    if (data.device === "s330" && !data.s330) {
      return false;
    }
    if (data.device === "s550" && !data.s550) {
      return false;
    }
    return true;
  },
  {
    message: "Device-specific extension must be present for the specified device type"
  }
);

// src/schemas/patch-schema.ts
import { z as z3 } from "zod";
var S330KeyModeSchema = z3.enum(["normal", "v-sw", "x-fade", "v-mix", "unison"]);
var S330AftertouchAssignSchema = z3.enum([
  "modulation",
  "volume",
  "bend+",
  "bend-",
  "filter"
]);
var S330KeyAssignSchema = z3.enum(["rotary", "fix"]);
var KeyGroupSchema = z3.object({
  /** Display name for this key group */
  name: z3.string().min(1).optional(),
  /** Reference to library tone by name */
  tone: z3.string().min(1),
  /** Key range [low, high] as MIDI note numbers */
  keyRange: KeyRangeSchema,
  /** Velocity range [min, max] (defaults to [1, 127]) */
  velocityRange: VelocityRangeSchema.optional(),
  /** Level adjustment (0-127) */
  level: z3.number().int().min(0).max(127).optional(),
  /** Pan position (-64 to +63, or 'center') */
  pan: z3.union([
    z3.literal("center"),
    z3.number().int().min(-64).max(63)
  ]).optional()
});
function createSeriesPatchExtensionSchema(maxTone) {
  return z3.object({
    benderRange: z3.number().int().min(0).max(12).optional(),
    aftertouchSens: z3.number().int().min(0).max(127).optional(),
    keyMode: S330KeyModeSchema.optional(),
    velocityThreshold: z3.number().int().min(0).max(127).optional(),
    octaveShift: z3.number().int().min(-2).max(2).optional(),
    detune: z3.number().int().min(-64).max(63).optional(),
    velocityMixRatio: z3.number().int().min(0).max(127).optional(),
    aftertouchAssign: S330AftertouchAssignSchema.optional(),
    keyAssign: S330KeyAssignSchema.optional(),
    outputAssign: z3.number().int().min(0).max(8).optional(),
    toneLayer1: z3.array(z3.number().int().min(-1).max(maxTone)).length(109).optional(),
    toneLayer2: z3.array(z3.number().int().min(-1).max(maxTone)).length(109).optional()
  });
}
var S330PatchExtensionSchema = createSeriesPatchExtensionSchema(31);
var S550PatchExtensionSchema = createSeriesPatchExtensionSchema(63);
var PatchYamlSchema = z3.object({
  /** Format identifier */
  format: z3.literal("sampler-patch"),
  /** Device type */
  device: DeviceTypeSchema,
  /** Schema version */
  version: z3.number().int().positive(),
  /** Patch name */
  name: z3.string().min(1).max(12),
  /** Level (0-127) */
  level: z3.number().int().min(0).max(127).optional(),
  /** Key groups (simplified representation) */
  keyGroups: z3.array(KeyGroupSchema).optional(),
  /** S-330 specific parameters */
  s330: S330PatchExtensionSchema.optional(),
  /** S-550 specific parameters */
  s550: S550PatchExtensionSchema.optional()
  // Future device extensions:
  // jv1080: JV1080PatchExtensionSchema.optional(),
  // d110: D110PatchExtensionSchema.optional(),
}).refine(
  (data) => {
    if (data.device === "s330" && !data.s330 && !data.keyGroups) {
      return false;
    }
    if (data.device === "s550" && !data.s550 && !data.keyGroups) {
      return false;
    }
    return true;
  },
  {
    message: "Patch must have either keyGroups or device-specific extension"
  }
);

// src/schemas/template-schema.ts
import { z as z4 } from "zod";
var TemplateTypeSchema = z4.enum(["drum-kit", "velocity-layer"]);
var DrumKitEntrySchema = z4.object({
  /** Display name for this drum element */
  name: z4.string().min(1),
  /** MIDI note (name like "C2" or number like 36) */
  key: MidiNoteSchema,
  /** Reference to library tone by name */
  tone: z4.string().min(1),
  /** Mute group for exclusive playback (e.g., hi-hat choke) */
  muteGroup: z4.number().int().min(1).max(16).optional(),
  /** Level adjustment (0-127) */
  level: z4.number().int().min(0).max(127).optional(),
  /** Pan position (-64 to +63, or 'center') */
  pan: z4.union([
    z4.literal("center"),
    z4.number().int().min(-64).max(63)
  ]).optional()
});
var VelocityLayerEntrySchema = z4.object({
  /** Velocity range [min, max] inclusive */
  range: VelocityRangeSchema,
  /** Reference to library tone by name */
  tone: z4.string().min(1)
});
var BaseTemplateSchema = z4.object({
  /** Format identifier */
  format: z4.literal("sampler-template"),
  /** Device type */
  device: DeviceTypeSchema,
  /** Schema version */
  version: z4.number().int().positive(),
  /** Template name */
  name: z4.string().min(1),
  /** Human-readable description */
  description: z4.string().optional()
});
var DrumKitTemplateSchema = BaseTemplateSchema.extend({
  /** Template type */
  type: z4.literal("drum-kit"),
  /** Kit entries mapping keys to tones */
  kit: z4.array(DrumKitEntrySchema).min(1)
});
var VelocityLayerTemplateBaseSchema = BaseTemplateSchema.extend({
  /** Template type */
  type: z4.literal("velocity-layer"),
  /** Key range for the multi-layer patch */
  keyRange: KeyRangeSchema,
  /** Velocity layers from soft to loud */
  velocityLayers: z4.array(VelocityLayerEntrySchema).min(1)
});
var VelocityLayerTemplateSchema = VelocityLayerTemplateBaseSchema.refine(
  (data) => {
    const sorted = [...data.velocityLayers].sort((a, b) => a.range[0] - b.range[0]);
    if (sorted[0] && sorted[0].range[0] !== 1) {
      return false;
    }
    const lastLayer = sorted[sorted.length - 1];
    if (lastLayer && lastLayer.range[1] !== 127) {
      return false;
    }
    for (let i = 1; i < sorted.length; i++) {
      const prev = sorted[i - 1];
      const curr = sorted[i];
      if (prev && curr && curr.range[0] !== prev.range[1] + 1) {
        return false;
      }
    }
    return true;
  },
  {
    message: "Velocity layers must cover the full range 1-127 without gaps"
  }
);
var TemplateYamlSchema = z4.discriminatedUnion("type", [
  DrumKitTemplateSchema,
  VelocityLayerTemplateBaseSchema
]);

// src/schemas/set-schema.ts
import { z as z5 } from "zod";
var WaveSegmentAllocationSchema = z5.object({
  /** Wave bank (0-1 for S-330, 0-3 for S-550) */
  bank: z5.union([z5.literal(0), z5.literal(1), z5.literal(2), z5.literal(3)]),
  /** First segment index (0-17) */
  segmentTop: z5.number().int().min(0).max(17),
  /** Number of segments used (1-18) */
  segmentLength: z5.number().int().min(1).max(18)
});
var SetToneEntrySchema = z5.object({
  /** Tone slot index (0-31 for S-330, 0-63 for S-550) */
  slot: z5.number().int().min(0).max(63),
  /** Filename reference (without extension, e.g., "T01" for T01.yaml + T01.wav) */
  file: z5.string().min(1),
  /** Wave memory allocation */
  waveAllocation: WaveSegmentAllocationSchema
});
var SetPatchEntrySchema = z5.object({
  /** Patch slot index (0-63 for S-330, 0-31 for S-550) */
  slot: z5.number().int().min(0).max(63),
  /** Filename reference (without extension, e.g., "P01" for P01.yaml) */
  file: z5.string().min(1)
});
var SetSystemParamsSchema = z5.object({
  /** Master tune offset */
  masterTune: z5.number().int().min(-64).max(63).optional(),
  /** Master output level (0-127) */
  masterLevel: z5.number().int().min(0).max(127).optional()
}).optional();
var SetYamlSchema = z5.object({
  /** Format identifier, always 'sampler-set' */
  format: z5.literal("sampler-set"),
  /** Device type */
  device: DeviceTypeSchema,
  /** Schema version for forward compatibility */
  version: z5.number().int().positive(),
  /** Human-readable set name */
  name: z5.string().min(1).max(64),
  /** Optional description */
  description: z5.string().max(256).optional(),
  /** Creation timestamp (ISO 8601) */
  createdAt: z5.string().datetime().optional(),
  /** Last modification timestamp (ISO 8601) */
  modifiedAt: z5.string().datetime().optional(),
  /** Tone slot assignments */
  tones: z5.array(SetToneEntrySchema),
  /** Patch slot assignments */
  patches: z5.array(SetPatchEntrySchema),
  /** Optional system parameters */
  system: SetSystemParamsSchema
});

// src/schemas/drum-kit-bundle-schema.ts
import { z as z6 } from "zod";
var DrumKitSamplesSchema = z6.object({
  /** Kick drum sample filename */
  kick: z6.string().min(1),
  /** Snare drum sample filename */
  snare: z6.string().min(1),
  /** Closed hi-hat sample filename */
  hhClosed: z6.string().min(1),
  /** Open hi-hat sample filename */
  hhOpen: z6.string().min(1)
});
var DrumKitEntryBundleSchema = z6.object({
  /** Sample file references */
  samples: DrumKitSamplesSchema
});
var SliceDefinitionSchema = z6.object({
  /** Human-readable label for this slice (e.g., "kick", "snare") */
  label: z6.string().min(1),
  /** Start position in samples (0-indexed) */
  startSample: z6.number().int().min(0),
  /** End position in samples (exclusive) */
  endSample: z6.number().int().min(0)
});
var DrumKitBundleSchema = z6.object({
  /** Format identifier - must be 'drum-kit-bundle' */
  format: z6.literal("drum-kit-bundle"),
  /** Schema version: 1 (individual WAVs) or 2 (source + slices) */
  version: z6.union([z6.literal(1), z6.literal(2)]),
  /** Human-readable name for the drum kit bundle */
  name: z6.string().min(1).max(64),
  /** Optional description */
  description: z6.string().optional(),
  /** Sample rate for all samples: 15000 or 30000 Hz (default: 15000) */
  sampleRate: z6.union([z6.literal(15e3), z6.literal(3e4)]).default(15e3),
  /** Base MIDI note for the first kit (default: C2 = MIDI 36) */
  baseNote: MidiNoteSchema.default("C2"),
  /**
   * Transpose value in semitones for pitch adjustment (-64 to +63, default: 0).
   * Use negative values to pitch down, positive to pitch up.
   * Common use case: sample at high speed, then pitch down for more sample time.
   */
  transpose: z6.number().int().min(-64).max(63).default(0).optional(),
  /**
   * Velocity-to-level sensitivity (0-5, default: 2).
   * Maps to the S-330's L-Curve (TVA Level Curve) parameter:
   * - 0: No velocity sensitivity (constant level)
   * - 5: Maximum velocity sensitivity
   */
  velocitySensitivity: z6.number().int().min(0).max(5).default(2).optional(),
  /**
   * Version 1: Optional explicit kit definitions.
   * If omitted, kits are auto-detected from filenames.
   */
  kits: z6.array(DrumKitEntryBundleSchema).optional(),
  /**
   * Version 2: Source WAV filename (e.g., "source.wav").
   * The full source audio is stored in this file.
   */
  source: z6.string().optional(),
  /**
   * Version 2: Slice definitions with sample boundaries.
   * Each slice references a region of the source WAV.
   */
  slices: z6.array(SliceDefinitionSchema).optional()
});

// src/schemas/sample-schema.ts
import { z as z8 } from "zod";

// src/schemas/chopped-sample-schema.ts
import { z as z7 } from "zod";
var TriggerMappingSchema = z7.object({
  /** Trigger identifier (e.g., "key:a", "midi:36") */
  triggerId: z7.string().min(1),
  /** Index into the slices array */
  sliceIndex: z7.number().int().min(0)
});
var PolyphonyModeSchema = z7.enum(["mono", "poly"]);
var PlaybackModeSchema = z7.enum(["one-shot", "gate"]);
var PlaybackConfigSchema = z7.object({
  /** Voice allocation mode */
  polyphony: PolyphonyModeSchema,
  /** How slices respond to note-on/off */
  playbackMode: PlaybackModeSchema,
  /** Mute group per slice. 0 = no mute group. Same non-zero group chokes. */
  muteGroups: z7.array(z7.number().int().min(0))
});
var DrumKitMetadataSchema = z7.object({
  /** Base MIDI note for the first slice */
  baseNote: MidiNoteSchema,
  /** Transpose in semitones (-64 to +63) */
  transpose: z7.number().int().min(-64).max(63).default(0).optional(),
  /** Velocity-to-level sensitivity (0-5) */
  velocitySensitivity: z7.number().int().min(0).max(5).default(2).optional()
});
var ChoppedSampleBaseFields = {
  /** Format identifier */
  format: z7.literal("chopped-sample"),
  /** Schema version */
  version: z7.literal(1),
  /** Human-readable name */
  name: z7.string().min(1).max(128),
  /** Optional description */
  description: z7.string().optional(),
  /** Source WAV filename */
  source: z7.string().min(1),
  /** Actual audio sample rate (unconstrained) */
  sampleRate: z7.number().int().positive(),
  /** Slice definitions referencing regions of the source WAV */
  slices: z7.array(SliceDefinitionSchema).min(1),
  /** Optional trigger mappings */
  triggers: z7.array(TriggerMappingSchema).optional(),
  /** Optional playback configuration */
  playback: PlaybackConfigSchema.optional(),
  /** ISO 8601 creation timestamp */
  createdAt: z7.string().optional(),
  /** ISO 8601 last modification timestamp */
  modifiedAt: z7.string().optional()
};
var GenericChoppedSampleSchema = z7.object(__spreadProps(__spreadValues({}, ChoppedSampleBaseFields), {
  variant: z7.literal("generic")
}));
var DrumKitChoppedSampleSchema = z7.object(__spreadProps(__spreadValues({}, ChoppedSampleBaseFields), {
  variant: z7.literal("drum-kit"),
  /** Drum kit specific parameters */
  drumKit: DrumKitMetadataSchema
}));
var ChoppedSampleSchema = z7.discriminatedUnion("variant", [
  GenericChoppedSampleSchema,
  DrumKitChoppedSampleSchema
]);

// src/schemas/sample-schema.ts
var SampleYamlSchema = z8.object({
  /** Format identifier */
  format: z8.literal("sample"),
  /** Schema version */
  version: z8.literal(1),
  /** Sample name (device limits applied at promotion, not storage) */
  name: z8.string().min(1).max(128),
  /** WAV filename (always 'sample.wav' for directory bundles) */
  file: z8.string().default("sample.wav"),
  /** Sample rate in Hz */
  sampleRate: z8.number().int().positive(),
  /** Loop playback mode (absent = one-shot) */
  loopMode: LoopModeSchema.optional(),
  /** Loop start point in samples */
  loopStart: z8.number().int().min(0).optional(),
  /** Loop end point in samples */
  loopEnd: z8.number().int().min(0).optional(),
  /** Original pitch of the sample (SFZ pitch_keycenter) */
  rootKey: MidiNoteSchema.optional(),
  /** Freeform tags for organization */
  tags: z8.array(z8.string()).optional(),
  /** Human-readable description */
  description: z8.string().optional(),
  /** Breadcrumb set when a device item is demoted to the common area */
  sourceDevice: z8.string().optional(),
  /** ISO 8601 creation timestamp */
  createdAt: z8.string().optional(),
  /** ISO 8601 last modification timestamp */
  modifiedAt: z8.string().optional(),
  // -- Slice fields (optional — present when sample has been chopped) --
  /** Slice definitions referencing regions of the source WAV */
  slices: z8.array(SliceDefinitionSchema).optional(),
  /** Trigger mappings associating MIDI notes/keys to slices */
  triggers: z8.array(TriggerMappingSchema).optional(),
  /** Playback configuration (polyphony, gate/one-shot, mute groups) */
  playback: PlaybackConfigSchema.optional(),
  /** Drum kit parameters (present when slices represent a drum kit) */
  drumKit: DrumKitMetadataSchema.optional()
}).refine(
  (data) => {
    if (data.loopStart !== void 0 && data.loopEnd !== void 0) {
      return data.loopEnd >= data.loopStart;
    }
    return true;
  },
  { message: "loopEnd must be >= loopStart when both are specified" }
);

// src/schemas/program-schema.ts
import { z as z9 } from "zod";
var SourceInfoSchema = z9.object({
  /** Name of the source sample this program was created from */
  sampleName: z9.string().min(1),
  /** Directory name of the source sample in the library (for lookup) */
  sampleDirectory: z9.string().min(1).optional()
});
var ZoneSchema = z9.object({
  /** Sample name or path reference (filename within the program bundle) */
  sample: z9.string().min(1),
  /** Key range [low, high] MIDI notes — when this zone is triggered */
  keyRange: KeyRangeSchema.optional(),
  /** Velocity range [low, high] — velocity layer boundaries */
  velocityRange: VelocityRangeSchema.optional(),
  /** Override the sample's rootKey for this zone (SFZ pitch_keycenter) */
  rootKey: MidiNoteSchema.optional(),
  /** Transpose in semitones */
  transpose: z9.number().int().min(-64).max(63).optional(),
  /** Fine tuning in cents */
  fineTune: z9.number().int().min(-64).max(63).optional(),
  /** Mute group: 0 = none, same non-zero group chokes (SFZ group/off_by) */
  muteGroup: z9.number().int().min(0).optional(),
  /** Human-readable label (e.g., "kick", "snare", "hi-hat open") */
  label: z9.string().optional()
});
var ProgramYamlSchema = z9.object({
  /** Format identifier */
  format: z9.literal("program"),
  /** Schema version */
  version: z9.literal(1),
  /** Program name */
  name: z9.string().min(1).max(128),
  /** Zones mapping samples to performance parameters */
  zones: z9.array(ZoneSchema).min(1),
  /** Voice allocation mode (mono/poly) */
  polyphony: PolyphonyModeSchema.optional(),
  /** How zones respond to note-on/off (one-shot/gate) */
  playbackMode: PlaybackModeSchema.optional(),
  /** Provenance: which source sample this program was created from */
  sourceInfo: SourceInfoSchema.optional(),
  /** Human-readable description */
  description: z9.string().optional(),
  /** Freeform tags for organization */
  tags: z9.array(z9.string()).optional(),
  /** ISO 8601 creation timestamp */
  createdAt: z9.string().optional(),
  /** ISO 8601 last modification timestamp */
  modifiedAt: z9.string().optional()
});

// src/converters/converter-registry.ts
var ConverterRegistry = class {
  constructor() {
    this.toneConverters = /* @__PURE__ */ new Map();
    this.patchConverters = /* @__PURE__ */ new Map();
  }
  /**
   * Register a tone converter for a device type.
   */
  registerToneConverter(converter3) {
    this.toneConverters.set(converter3.deviceType, converter3);
  }
  /**
   * Register a patch converter for a device type.
   */
  registerPatchConverter(converter3) {
    this.patchConverters.set(converter3.deviceType, converter3);
  }
  /**
   * Get the tone converter for a device type.
   */
  getToneConverter(deviceType) {
    return this.toneConverters.get(deviceType);
  }
  /**
   * Get the patch converter for a device type.
   */
  getPatchConverter(deviceType) {
    return this.patchConverters.get(deviceType);
  }
  /**
   * Check if a tone converter exists for a device type.
   */
  hasToneConverter(deviceType) {
    return this.toneConverters.has(deviceType);
  }
  /**
   * Check if a patch converter exists for a device type.
   */
  hasPatchConverter(deviceType) {
    return this.patchConverters.has(deviceType);
  }
  /**
   * Get all registered device types for tone converters.
   */
  getRegisteredToneDevices() {
    return Array.from(this.toneConverters.keys());
  }
  /**
   * Get all registered device types for patch converters.
   */
  getRegisteredPatchDevices() {
    return Array.from(this.patchConverters.keys());
  }
};
var converterRegistry = new ConverterRegistry();

// src/converters/s-series/tone-converter.ts
import { sampleRateLabelToHz } from "@audiocontrol/sampler-devices/roland-s-series";
function mapLoopModeToYaml(mode) {
  switch (mode) {
    case "forward":
      return "forward";
    case "alternating":
      return "alternating";
    case "one-shot":
      return "oneShot";
    case "reverse":
      return "reverse";
  }
}
function mapLoopModeFromYaml(mode) {
  switch (mode) {
    case "forward":
      return "forward";
    case "alternating":
      return "alternating";
    case "oneShot":
      return "one-shot";
    case "reverse":
      return "reverse";
  }
}
function mapSampleRateFromHz(hz) {
  return hz >= 3e4 ? "30kHz" : "15kHz";
}
function envelopeToYaml(env) {
  return {
    levels: env.levels,
    rates: env.rates,
    sustainPoint: env.sustainPoint,
    endPoint: env.endPoint
  };
}
function envelopeFromYaml(yaml) {
  return {
    levels: yaml.levels,
    rates: yaml.rates,
    sustainPoint: yaml.sustainPoint,
    endPoint: yaml.endPoint
  };
}
function lfoToYaml(lfo) {
  return {
    rate: lfo.rate,
    sync: lfo.sync,
    delay: lfo.delay,
    mode: lfo.mode === "one-shot" ? "one-shot" : "normal",
    polarity: lfo.polarity,
    offset: lfo.offset
  };
}
function lfoFromYaml(yaml) {
  var _a, _b;
  return {
    rate: yaml.rate,
    sync: yaml.sync,
    delay: yaml.delay,
    mode: yaml.mode,
    polarity: (_a = yaml.polarity) != null ? _a : false,
    offset: (_b = yaml.offset) != null ? _b : 0
  };
}
function tvfToYaml(tvf) {
  return {
    cutoff: tvf.cutoff,
    resonance: tvf.resonance,
    keyFollow: tvf.keyFollow,
    lfoDepth: tvf.lfoDepth,
    egDepth: tvf.egDepth,
    egPolarity: tvf.egPolarity,
    levelCurve: tvf.levelCurve,
    keyRateFollow: tvf.keyRateFollow,
    velRateFollow: tvf.velRateFollow,
    enabled: tvf.enabled,
    envelope: envelopeToYaml(tvf.envelope)
  };
}
function tvfFromYaml(yaml) {
  var _a, _b, _c, _d;
  const defaultEnvelope = {
    levels: [127, 127, 127, 127, 127, 127, 127, 0],
    rates: [127, 127, 127, 127, 127, 127, 127, 127],
    sustainPoint: 6,
    endPoint: 8
  };
  return {
    cutoff: yaml.cutoff,
    resonance: yaml.resonance,
    keyFollow: yaml.keyFollow,
    lfoDepth: (_a = yaml.lfoDepth) != null ? _a : 0,
    egDepth: yaml.egDepth,
    egPolarity: yaml.egPolarity,
    levelCurve: (_b = yaml.levelCurve) != null ? _b : 0,
    keyRateFollow: (_c = yaml.keyRateFollow) != null ? _c : 0,
    velRateFollow: (_d = yaml.velRateFollow) != null ? _d : 0,
    enabled: yaml.enabled,
    envelope: yaml.envelope ? envelopeFromYaml(yaml.envelope) : defaultEnvelope
  };
}
function tvaToYaml(tva) {
  return {
    level: tva.level,
    lfoDepth: tva.lfoDepth,
    keyRate: tva.keyRate,
    velRate: tva.velRate,
    levelCurve: tva.levelCurve,
    envelope: envelopeToYaml(tva.envelope)
  };
}
function tvaFromYaml(yaml) {
  var _a, _b, _c, _d;
  return {
    level: yaml.level,
    lfoDepth: (_a = yaml.lfoDepth) != null ? _a : 0,
    keyRate: (_b = yaml.keyRate) != null ? _b : 0,
    velRate: (_c = yaml.velRate) != null ? _c : 0,
    levelCurve: (_d = yaml.levelCurve) != null ? _d : 0,
    envelope: envelopeFromYaml(yaml.envelope)
  };
}
function toneToExtension(tone) {
  return {
    originalKey: tone.originalKey,
    outputAssign: tone.outputAssign,
    sourceTone: tone.sourceTone,
    transpose: tone.transpose,
    fineTune: tone.fineTune,
    lfo: lfoToYaml(tone.lfo),
    tvf: tvfToYaml(tone.tvf),
    tva: tvaToYaml(tone.tva),
    benderEnabled: tone.benderEnabled,
    aftertouchEnabled: tone.aftertouchEnabled,
    pitchFollow: tone.pitchFollow
  };
}
function extensionToTone(ext, yaml) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const defaultLfo = {
    rate: 0,
    sync: false,
    delay: 0,
    mode: "normal",
    polarity: false,
    offset: 0
  };
  const defaultTvf = {
    cutoff: 127,
    resonance: 0,
    keyFollow: 0,
    lfoDepth: 0,
    egDepth: 0,
    egPolarity: "normal",
    levelCurve: 0,
    keyRateFollow: 0,
    velRateFollow: 0,
    enabled: true,
    envelope: {
      levels: [127, 127, 127, 127, 127, 127, 127, 0],
      rates: [127, 127, 127, 127, 127, 127, 127, 127],
      sustainPoint: 6,
      endPoint: 8
    }
  };
  const defaultTva = {
    level: 127,
    lfoDepth: 0,
    keyRate: 0,
    velRate: 0,
    levelCurve: 0,
    envelope: {
      levels: [127, 127, 127, 127, 127, 127, 127, 0],
      rates: [127, 127, 127, 127, 127, 127, 127, 127],
      sustainPoint: 6,
      endPoint: 8
    }
  };
  return {
    name: yaml.name,
    outputAssign: ext.outputAssign,
    sourceTone: (_a = ext.sourceTone) != null ? _a : 0,
    origSubTone: 0,
    sampleRate: mapSampleRateFromHz(yaml.wave.sampleRate),
    originalKey: ext.originalKey,
    wave: {
      bank: 0,
      segmentTop: 0,
      segmentLength: 0,
      startPoint: (_b = yaml.wave.startPoint) != null ? _b : 0,
      endPoint: (_c = yaml.wave.endPoint) != null ? _c : 0,
      loopPoint: (_d = yaml.wave.loopPoint) != null ? _d : 0,
      loopLength: 0
    },
    loopMode: mapLoopModeFromYaml(yaml.wave.loopMode),
    lfo: ext.lfo ? lfoFromYaml(ext.lfo) : defaultLfo,
    transpose: (_e = ext.transpose) != null ? _e : 0,
    fineTune: (_f = ext.fineTune) != null ? _f : 0,
    tvf: ext.tvf ? tvfFromYaml(ext.tvf) : defaultTvf,
    tva: ext.tva ? tvaFromYaml(ext.tva) : defaultTva,
    benderEnabled: (_g = ext.benderEnabled) != null ? _g : true,
    aftertouchEnabled: (_h = ext.aftertouchEnabled) != null ? _h : true,
    pitchFollow: (_i = ext.pitchFollow) != null ? _i : true,
    recThreshold: 0,
    recPreTrigger: 0,
    loopTune: 0,
    envZoom: 0,
    copySource: 0
  };
}
function createSeriesToneConverter(deviceType) {
  return {
    deviceType,
    toYaml(tone, wavFilename) {
      const extension = toneToExtension(tone);
      return {
        format: "sampler-tone",
        device: deviceType,
        version: 1,
        name: tone.name,
        wave: {
          file: wavFilename,
          sampleRate: sampleRateLabelToHz(tone.sampleRate),
          loopMode: mapLoopModeToYaml(tone.loopMode),
          startPoint: tone.wave.startPoint || void 0,
          endPoint: tone.wave.endPoint || void 0,
          loopPoint: tone.wave.loopPoint || void 0
        },
        [deviceType]: extension
      };
    },
    fromYaml(yaml) {
      const ext = yaml[deviceType];
      if (yaml.device !== deviceType || !ext) {
        throw new Error(`Invalid YAML: expected ${deviceType} device with ${deviceType} extension`);
      }
      return extensionToTone(ext, yaml);
    }
  };
}

// src/converters/s330/tone-converter.ts
var s330ToneConverter = createSeriesToneConverter("s330");

// src/converters/s-series/patch-converter.ts
function createEmptyToneLayer(layer) {
  return new Array(109).fill(layer === 1 ? -1 : 0);
}
function setToneForMidiRange(layer, lowKey, highKey, toneIndex) {
  const TONE_LAYER_MIN_MIDI_NOTE = 12;
  for (let note = lowKey; note <= highKey; note++) {
    const layerIndex = note - TONE_LAYER_MIN_MIDI_NOTE;
    if (layerIndex >= 0 && layerIndex < 109) {
      layer[layerIndex] = toneIndex;
    }
  }
}
function createSeriesPatchConverter(deviceType) {
  return {
    deviceType,
    toYaml(patch) {
      const common = patch.common;
      const extension = {
        benderRange: common.benderRange,
        aftertouchSens: common.aftertouchSens,
        keyMode: common.keyMode,
        velocityThreshold: common.velocityThreshold,
        octaveShift: common.octaveShift,
        detune: common.detune,
        velocityMixRatio: common.velocityMixRatio,
        aftertouchAssign: common.aftertouchAssign,
        keyAssign: common.keyAssign,
        outputAssign: common.outputAssign,
        toneLayer1: common.toneLayer1,
        toneLayer2: common.toneLayer2
      };
      return {
        format: "sampler-patch",
        device: deviceType,
        version: 1,
        name: common.name,
        level: common.level,
        [deviceType]: extension
      };
    },
    fromYaml(yaml) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m;
      if (yaml.device !== deviceType) {
        throw new Error(`Invalid YAML: expected ${deviceType} device`);
      }
      const ext = yaml[deviceType];
      const toneLayer1 = (_a = ext == null ? void 0 : ext.toneLayer1) != null ? _a : createEmptyToneLayer(1);
      const toneLayer2 = (_b = ext == null ? void 0 : ext.toneLayer2) != null ? _b : createEmptyToneLayer(2);
      const common = {
        name: yaml.name,
        benderRange: (_c = ext == null ? void 0 : ext.benderRange) != null ? _c : 2,
        aftertouchSens: (_d = ext == null ? void 0 : ext.aftertouchSens) != null ? _d : 64,
        keyMode: (_e = ext == null ? void 0 : ext.keyMode) != null ? _e : "normal",
        velocityThreshold: (_f = ext == null ? void 0 : ext.velocityThreshold) != null ? _f : 64,
        toneLayer1,
        toneLayer2,
        copySource: 0,
        octaveShift: (_g = ext == null ? void 0 : ext.octaveShift) != null ? _g : 0,
        level: (_h = yaml.level) != null ? _h : 100,
        detune: (_i = ext == null ? void 0 : ext.detune) != null ? _i : 0,
        velocityMixRatio: (_j = ext == null ? void 0 : ext.velocityMixRatio) != null ? _j : 64,
        aftertouchAssign: (_k = ext == null ? void 0 : ext.aftertouchAssign) != null ? _k : "modulation",
        keyAssign: (_l = ext == null ? void 0 : ext.keyAssign) != null ? _l : "rotary",
        outputAssign: (_m = ext == null ? void 0 : ext.outputAssign) != null ? _m : 8
      };
      return { common };
    }
  };
}
function createSeriesPatchFromKeyGroups(name, keyGroups, toneNameToIndex) {
  var _a;
  const toneLayer1 = createEmptyToneLayer(1);
  const toneLayer2 = createEmptyToneLayer(2);
  for (const group of keyGroups) {
    const toneIndex = toneNameToIndex.get(group.tone);
    if (toneIndex === void 0) {
      throw new Error(`Tone not found in library: ${group.tone}`);
    }
    const [lowKey, highKey] = group.keyRange;
    const layer = (_a = group.layer) != null ? _a : 1;
    const targetLayer = layer === 1 ? toneLayer1 : toneLayer2;
    setToneForMidiRange(targetLayer, lowKey, highKey, toneIndex);
  }
  return {
    common: {
      name: name.slice(0, 12),
      benderRange: 2,
      aftertouchSens: 64,
      keyMode: "normal",
      velocityThreshold: 64,
      toneLayer1,
      toneLayer2,
      copySource: 0,
      octaveShift: 0,
      level: 100,
      detune: 0,
      velocityMixRatio: 64,
      aftertouchAssign: "modulation",
      keyAssign: "rotary",
      outputAssign: 8
    }
  };
}

// src/converters/s330/patch-converter.ts
var s330PatchConverter = createSeriesPatchConverter("s330");
function createPatchFromKeyGroups(name, keyGroups, toneNameToIndex) {
  return createSeriesPatchFromKeyGroups(name, keyGroups, toneNameToIndex);
}

// src/storage/set-paths.ts
function getToneFilename(slot) {
  if (slot < 0 || slot > 63) {
    throw new Error(`Invalid tone slot index: ${slot}. Must be 0-63.`);
  }
  return `T${String(slot + 1).padStart(2, "0")}`;
}
function getPatchFilename(slot) {
  if (slot < 0 || slot > 63) {
    throw new Error(`Invalid patch slot index: ${slot}. Must be 0-63.`);
  }
  return `P${String(slot + 1).padStart(2, "0")}`;
}

// src/converters/s-series/set-converter.ts
function createSeriesSetConverter(config) {
  const { deviceType, toneConverter, patchConverter, bankCount } = config;
  function deviceStateToSet3(setName, description, input) {
    const now = (/* @__PURE__ */ new Date()).toISOString();
    const toneEntries = [];
    const patchEntries = [];
    const convertedTones = /* @__PURE__ */ new Map();
    const convertedPatches = /* @__PURE__ */ new Map();
    for (let slot = 0; slot < input.tones.length; slot++) {
      const tone = input.tones[slot];
      if (tone === null) continue;
      const waveInfo = input.waveData.get(slot);
      if (!waveInfo) continue;
      const toneFile = getToneFilename(slot);
      const wavFilename = `${toneFile}.wav`;
      const yaml = toneConverter.toYaml(tone, wavFilename);
      const sampleRateHz = waveInfo.sampleRate;
      const allocation = {
        bank: tone.wave.bank,
        segmentTop: tone.wave.segmentTop,
        segmentLength: tone.wave.segmentLength
      };
      toneEntries.push({
        slot,
        file: toneFile,
        waveAllocation: allocation
      });
      convertedTones.set(slot, {
        yaml,
        wavData: waveInfo.data,
        sampleRate: sampleRateHz
      });
    }
    for (let slot = 0; slot < input.patches.length; slot++) {
      const patch = input.patches[slot];
      if (patch === null) continue;
      const patchFile = getPatchFilename(slot);
      const yaml = patchConverter.toYaml(patch);
      patchEntries.push({
        slot,
        file: patchFile
      });
      convertedPatches.set(slot, yaml);
    }
    const manifest = {
      format: "sampler-set",
      device: deviceType,
      version: 1,
      name: setName,
      description,
      createdAt: now,
      modifiedAt: now,
      tones: toneEntries.sort((a, b) => a.slot - b.slot),
      patches: patchEntries.sort((a, b) => a.slot - b.slot)
    };
    return {
      manifest,
      tones: convertedTones,
      patches: convertedPatches
    };
  }
  function setToDeviceState3(input) {
    const resultTones = /* @__PURE__ */ new Map();
    const resultPatches = /* @__PURE__ */ new Map();
    const allocations = /* @__PURE__ */ new Map();
    for (const entry of input.manifest.tones) {
      allocations.set(entry.slot, entry.waveAllocation);
    }
    for (const [slot, data] of input.tones) {
      const tone = toneConverter.fromYaml(data.yaml);
      const allocation = allocations.get(slot);
      if (allocation) {
        tone.wave.bank = allocation.bank;
        tone.wave.segmentTop = allocation.segmentTop;
        tone.wave.segmentLength = allocation.segmentLength;
      }
      resultTones.set(slot, {
        tone,
        wavData: data.wavData
      });
    }
    for (const [slot, yaml] of input.patches) {
      const patch = patchConverter.fromYaml(yaml);
      resultPatches.set(slot, patch);
    }
    return {
      tones: resultTones,
      patches: resultPatches,
      allocations
    };
  }
  function validateSetAllocations3(manifest) {
    var _a, _b;
    const errors = [];
    const bankUsage = [];
    for (let i = 0; i < bankCount; i++) {
      bankUsage.push(/* @__PURE__ */ new Set());
    }
    for (const entry of manifest.tones) {
      const { bank, segmentTop, segmentLength } = entry.waveAllocation;
      if (bank >= bankCount) {
        errors.push(`Tone ${entry.file} has invalid bank ${bank} (must be 0-${bankCount - 1})`);
        continue;
      }
      for (let seg = segmentTop; seg < segmentTop + segmentLength; seg++) {
        if (seg > 17) {
          errors.push(
            `Tone ${entry.file} allocation exceeds bank capacity (segment ${seg} > 17)`
          );
          continue;
        }
        if ((_a = bankUsage[bank]) == null ? void 0 : _a.has(seg)) {
          errors.push(
            `Tone ${entry.file} allocation overlaps with another tone at bank ${bank} segment ${seg}`
          );
        } else {
          (_b = bankUsage[bank]) == null ? void 0 : _b.add(seg);
        }
      }
    }
    return errors;
  }
  function calculateSetSegmentUsage3(manifest) {
    const usage = {};
    for (let i = 0; i < bankCount; i++) {
      usage[`bank${i}`] = 0;
    }
    for (const entry of manifest.tones) {
      const bank = entry.waveAllocation.bank;
      const key = `bank${bank}`;
      const maxSegment = entry.waveAllocation.segmentTop + entry.waveAllocation.segmentLength;
      if (key in usage) {
        usage[key] = Math.max(usage[key], maxSegment);
      }
    }
    return usage;
  }
  return {
    deviceStateToSet: deviceStateToSet3,
    setToDeviceState: setToDeviceState3,
    validateSetAllocations: validateSetAllocations3,
    calculateSetSegmentUsage: calculateSetSegmentUsage3
  };
}

// src/converters/s330/set-converter.ts
var converter = createSeriesSetConverter({
  deviceType: "s330",
  toneConverter: s330ToneConverter,
  patchConverter: s330PatchConverter,
  bankCount: 2
});
var { deviceStateToSet, setToDeviceState, validateSetAllocations } = converter;
function calculateSetSegmentUsage(manifest) {
  return converter.calculateSetSegmentUsage(manifest);
}

// src/converters/s330/index.ts
import {
  parseWav,
  createWav,
  wavToS330,
  s330ToWav,
  calculateSegmentsNeeded,
  validateWaveDataFits
} from "@audiocontrol/sampler-devices/s330";

// src/converters/s550/tone-converter.ts
var s550ToneConverter = createSeriesToneConverter("s550");

// src/converters/s550/patch-converter.ts
var s550PatchConverter = createSeriesPatchConverter("s550");
function createPatchFromKeyGroups2(name, keyGroups, toneNameToIndex) {
  return createSeriesPatchFromKeyGroups(name, keyGroups, toneNameToIndex);
}

// src/converters/s550/set-converter.ts
var converter2 = createSeriesSetConverter({
  deviceType: "s550",
  toneConverter: s550ToneConverter,
  patchConverter: s550PatchConverter,
  bankCount: 4
});
var { deviceStateToSet: deviceStateToSet2, setToDeviceState: setToDeviceState2, validateSetAllocations: validateSetAllocations2 } = converter2;
function calculateSetSegmentUsage2(manifest) {
  return converter2.calculateSetSegmentUsage(manifest);
}

// src/converters/s550/index.ts
import {
  parseWav as parseWav2,
  createWav as createWav2,
  wavToSeries,
  seriesToWav,
  calculateSegmentsNeeded as calculateSegmentsNeeded2,
  validateWaveDataFits as validateWaveDataFits2
} from "@audiocontrol/sampler-devices/s550";

// src/converters/promotion.ts
var TONE_NAME_MAX_LENGTH = 12;
function createSeriesPromotionConverter(deviceType) {
  return {
    deviceType,
    promote(sample, defaults) {
      var _a, _b, _c, _d;
      const loopMode = (_a = sample.loopMode) != null ? _a : sample.loopStart !== void 0 ? "forward" : "oneShot";
      const tone = {
        format: "sampler-tone",
        device: deviceType,
        version: 1,
        name: sample.name.slice(0, TONE_NAME_MAX_LENGTH),
        wave: {
          file: sample.file,
          sampleRate: sample.sampleRate,
          loopMode,
          loopPoint: sample.loopStart,
          endPoint: sample.loopEnd
        },
        [deviceType]: {
          originalKey: defaults.originalKey,
          outputAssign: (_b = defaults.outputAssign) != null ? _b : 0,
          transpose: (_c = defaults.transpose) != null ? _c : 0,
          fineTune: (_d = defaults.fineTune) != null ? _d : 0
        }
      };
      return tone;
    },
    demote(tone) {
      var _a;
      const extension = (_a = tone.s330) != null ? _a : tone.s550;
      const rootKey = extension == null ? void 0 : extension.originalKey;
      const sample = {
        format: "sample",
        version: 1,
        name: tone.name,
        file: tone.wave.file,
        sampleRate: tone.wave.sampleRate,
        loopMode: tone.wave.loopMode,
        loopStart: tone.wave.loopPoint,
        loopEnd: tone.wave.endPoint,
        rootKey,
        sourceDevice: tone.device
      };
      return sample;
    }
  };
}
var s330SamplePromotion = createSeriesPromotionConverter("s330");
var s550SamplePromotion = createSeriesPromotionConverter("s550");

// src/converters/chopped-sample-converter.ts
function drumKitBundleToChoppedSample(bundle, resolvedBaseNote) {
  if (bundle.version !== 2) {
    throw new Error("Only DrumKitBundle version 2 (source + slices) can be converted");
  }
  if (!bundle.source || !bundle.slices || bundle.slices.length === 0) {
    throw new Error("DrumKitBundle must have source and slices for conversion");
  }
  return {
    format: "chopped-sample",
    version: 1,
    variant: "drum-kit",
    name: bundle.name,
    description: bundle.description,
    source: bundle.source,
    sampleRate: bundle.sampleRate,
    slices: bundle.slices.map((s) => ({
      label: s.label,
      startSample: s.startSample,
      endSample: s.endSample
    })),
    drumKit: {
      baseNote: resolvedBaseNote != null ? resolvedBaseNote : bundle.baseNote,
      transpose: bundle.transpose,
      velocitySensitivity: bundle.velocitySensitivity
    }
  };
}
function choppedSampleToDrumKitBundle(chopped, targetSampleRate) {
  if (chopped.variant !== "drum-kit") {
    throw new Error("Only drum-kit variant ChoppedSamples can be converted to DrumKitBundle");
  }
  const drumKit = chopped;
  const slices = chopped.slices.map((s) => ({
    label: s.label,
    startSample: s.startSample,
    endSample: s.endSample
  }));
  return {
    format: "drum-kit-bundle",
    version: 2,
    name: chopped.name,
    description: chopped.description,
    sampleRate: targetSampleRate,
    baseNote: drumKit.drumKit.baseNote,
    transpose: drumKit.drumKit.transpose,
    velocitySensitivity: drumKit.drumKit.velocitySensitivity,
    source: chopped.source,
    slices
  };
}
function createGenericChoppedSample(name, sampleRate, slices) {
  return {
    format: "chopped-sample",
    version: 1,
    variant: "generic",
    name,
    source: "source.wav",
    sampleRate,
    slices
  };
}

// src/templates/template-engine.ts
function parseNoteName(noteName) {
  return parseMidiNote(noteName);
}
function validateToneReferences(toneNames, availableTones) {
  return toneNames.filter((name) => !availableTones.has(name));
}
var TemplateHandlerRegistry = class {
  constructor() {
    this.handlers = /* @__PURE__ */ new Map();
  }
  /**
   * Register a template handler for a device type.
   */
  register(handler) {
    this.handlers.set(handler.deviceType, handler);
  }
  /**
   * Get the template handler for a device type.
   */
  get(deviceType) {
    return this.handlers.get(deviceType);
  }
  /**
   * Check if a handler exists for a device type.
   */
  has(deviceType) {
    return this.handlers.has(deviceType);
  }
};
var templateHandlerRegistry = new TemplateHandlerRegistry();

// src/converters/chopped-sample-migration.ts
function buildZone(chopped, sliceIndex) {
  var _a;
  const slice = chopped.slices[sliceIndex];
  if (!slice) {
    throw new Error(`Slice index ${sliceIndex} out of bounds`);
  }
  const zone = {
    sample: chopped.source,
    label: slice.label
  };
  if (chopped.variant === "drum-kit") {
    const baseNote = resolveKey(chopped.drumKit.baseNote);
    const noteNumber = baseNote + sliceIndex;
    zone.keyRange = [noteNumber, noteNumber];
  }
  const muteGroup = (_a = chopped.playback) == null ? void 0 : _a.muteGroups[sliceIndex];
  if (muteGroup !== void 0 && muteGroup !== 0) {
    zone.muteGroup = muteGroup;
  }
  return zone;
}
function migrateChoppedSample(chopped) {
  var _a, _b;
  const sample = {
    format: "sample",
    version: 1,
    name: chopped.name,
    file: chopped.source,
    sampleRate: chopped.sampleRate,
    description: chopped.description,
    createdAt: chopped.createdAt,
    modifiedAt: chopped.modifiedAt
  };
  const zones = chopped.slices.map(
    (_, index) => buildZone(chopped, index)
  );
  const program = {
    format: "program",
    version: 1,
    name: chopped.name,
    zones,
    polyphony: (_a = chopped.playback) == null ? void 0 : _a.polyphony,
    playbackMode: (_b = chopped.playback) == null ? void 0 : _b.playbackMode,
    description: chopped.description,
    createdAt: chopped.createdAt,
    modifiedAt: chopped.modifiedAt
  };
  return { sample, program };
}

// src/converters/index.ts
converterRegistry.registerToneConverter(s330ToneConverter);
converterRegistry.registerPatchConverter(s330PatchConverter);
converterRegistry.registerToneConverter(s550ToneConverter);
converterRegistry.registerPatchConverter(s550PatchConverter);

// src/templates/s330-handler.ts
import {
  createEmptyToneLayer as createEmptyToneLayer2,
  midiNoteToLayerIndex
} from "@audiocontrol/sampler-devices/s330";
function createDefaultPatchCommon(name) {
  return {
    name: name.slice(0, 12),
    benderRange: 2,
    aftertouchSens: 64,
    keyMode: "normal",
    velocityThreshold: 64,
    toneLayer1: createEmptyToneLayer2(1),
    toneLayer2: createEmptyToneLayer2(2),
    copySource: 0,
    octaveShift: 0,
    level: 100,
    detune: 0,
    velocityMixRatio: 64,
    aftertouchAssign: "modulation",
    keyAssign: "rotary",
    outputAssign: 8
  };
}
var s330TemplateHandler = {
  deviceType: "s330",
  applyDrumKit(template, availableTones, toneNameToIndex) {
    var _a;
    const warnings = [];
    const referencedTones = [];
    for (const entry of template.kit) {
      referencedTones.push(entry.tone);
    }
    const missingTones = validateToneReferences(referencedTones, availableTones);
    if (missingTones.length > 0) {
      for (const missing of missingTones) {
        warnings.push(`Tone not found in library: ${missing}`);
      }
    }
    const common = createDefaultPatchCommon(template.name);
    const muteGroups = /* @__PURE__ */ new Map();
    for (const entry of template.kit) {
      const toneIndex = toneNameToIndex.get(entry.tone);
      if (toneIndex === void 0) {
        continue;
      }
      const midiNote = resolveKey(entry.key);
      const layerIndex = midiNoteToLayerIndex(midiNote);
      if (layerIndex < 0) {
        warnings.push(
          `Key ${entry.key} (MIDI ${midiNote}) is outside S-330 range (21-127), skipping ${entry.name}`
        );
        continue;
      }
      common.toneLayer1[layerIndex] = toneIndex;
      if (entry.muteGroup !== void 0) {
        const group = (_a = muteGroups.get(entry.muteGroup)) != null ? _a : [];
        group.push(midiNote);
        muteGroups.set(entry.muteGroup, group);
      }
    }
    if (muteGroups.size > 0) {
      warnings.push(
        "Mute groups are not natively supported on S-330. They have been ignored."
      );
    }
    const patch = { common };
    return {
      patches: [patch],
      referencedTones: [...new Set(referencedTones)],
      warnings
    };
  },
  applyVelocityLayer(template, availableTones, toneNameToIndex) {
    const warnings = [];
    const referencedTones = [];
    for (const layer of template.velocityLayers) {
      referencedTones.push(layer.tone);
    }
    const missingTones = validateToneReferences(referencedTones, availableTones);
    if (missingTones.length > 0) {
      for (const missing of missingTones) {
        warnings.push(`Tone not found in library: ${missing}`);
      }
    }
    const layers = template.velocityLayers;
    if (layers.length > 2) {
      warnings.push(
        `S-330 only supports 2 velocity layers. Using first and last of ${layers.length} layers.`
      );
    }
    const softLayer = layers[0];
    const loudLayer = layers[layers.length - 1];
    if (!softLayer || !loudLayer) {
      return {
        patches: [],
        referencedTones: [...new Set(referencedTones)],
        warnings: ["No velocity layers defined"]
      };
    }
    const softToneIndex = toneNameToIndex.get(softLayer.tone);
    const loudToneIndex = toneNameToIndex.get(loudLayer.tone);
    if (softToneIndex === void 0 || loudToneIndex === void 0) {
      return {
        patches: [],
        referencedTones: [...new Set(referencedTones)],
        warnings
      };
    }
    const common = createDefaultPatchCommon(template.name);
    common.keyMode = "v-sw";
    if (layers.length >= 2 && layers[1]) {
      common.velocityThreshold = layers[1].range[0];
    } else {
      common.velocityThreshold = 64;
    }
    const [lowKey, highKey] = template.keyRange;
    for (let midiNote = lowKey; midiNote <= highKey; midiNote++) {
      const layerIndex = midiNoteToLayerIndex(midiNote);
      if (layerIndex >= 0) {
        common.toneLayer1[layerIndex] = softToneIndex;
        common.toneLayer2[layerIndex] = loudToneIndex;
      }
    }
    const patch = { common };
    return {
      patches: [patch],
      referencedTones: [...new Set(referencedTones)],
      warnings
    };
  }
};

// src/templates/index.ts
templateHandlerRegistry.register(s330TemplateHandler);

// src/drum-kits/drum-kit-parser.ts
var DRUM_PATTERNS = [
  // Preferred format: number first (e.g., "01 KICK", "01_KICK", "01-KICK")
  { pattern: /^(\d+)[_\s-]?kick/i, type: "kick" },
  { pattern: /^(\d+)[_\s-]?snare/i, type: "snare" },
  { pattern: /^(\d+)[_\s-]?hhc/i, type: "hhClosed" },
  { pattern: /^(\d+)[_\s-]?hho/i, type: "hhOpen" },
  // Legacy format: name first (e.g., "KICK 01", "kick01", "kick_01")
  { pattern: /^kick[_\s-]?(\d+)/i, type: "kick" },
  { pattern: /^snare[_\s-]?(\d+)/i, type: "snare" },
  { pattern: /^hhc[_\s-]?(\d+)/i, type: "hhClosed" },
  { pattern: /^hho[_\s-]?(\d+)/i, type: "hhOpen" },
  // Additional patterns for common naming conventions
  { pattern: /^(\d+)[_\s-]?closed[_\s-]?hat/i, type: "hhClosed" },
  { pattern: /^(\d+)[_\s-]?open[_\s-]?hat/i, type: "hhOpen" },
  { pattern: /^closed[_\s-]?hat[_\s-]?(\d+)/i, type: "hhClosed" },
  { pattern: /^open[_\s-]?hat[_\s-]?(\d+)/i, type: "hhOpen" },
  { pattern: /^hihat[_\s-]?closed[_\s-]?(\d+)/i, type: "hhClosed" },
  { pattern: /^hihat[_\s-]?open[_\s-]?(\d+)/i, type: "hhOpen" }
];
function parseDrumFilename(filename) {
  var _a;
  const baseName = (_a = filename.replace(/\.wav$/i, "").split("/").pop()) != null ? _a : "";
  for (const { pattern, type } of DRUM_PATTERNS) {
    const match = baseName.match(pattern);
    if (match == null ? void 0 : match[1]) {
      const kitNumber = parseInt(match[1], 10);
      if (!isNaN(kitNumber) && kitNumber > 0) {
        return {
          type,
          kitNumber,
          filename
        };
      }
    }
  }
  return null;
}
function resolveMidiNotes(baseNote, kitIndex) {
  const start = baseNote + kitIndex * 4;
  return {
    kick: start,
    snare: start + 1,
    hhClosed: start + 2,
    hhOpen: start + 3
  };
}
function parseDrumKitDirectory(files, baseNote = 36) {
  const samples = files.map(parseDrumFilename).filter((s) => s !== null);
  const kitMap = /* @__PURE__ */ new Map();
  for (const sample of samples) {
    let kit = kitMap.get(sample.kitNumber);
    if (!kit) {
      kit = {};
      kitMap.set(sample.kitNumber, kit);
    }
    kit[sample.type] = sample.filename;
  }
  const kitNumbers = Array.from(kitMap.keys()).sort((a, b) => a - b);
  return kitNumbers.map((kitNumber, index) => {
    const samples2 = kitMap.get(kitNumber);
    const isComplete = Boolean(
      samples2.kick && samples2.snare && samples2.hhClosed && samples2.hhOpen
    );
    return {
      kitNumber,
      samples: samples2,
      midiNotes: resolveMidiNotes(baseNote, index),
      isComplete
    };
  });
}
function countKitSamples(samples) {
  let count = 0;
  if (samples.kick) count++;
  if (samples.snare) count++;
  if (samples.hhClosed) count++;
  if (samples.hhOpen) count++;
  return count;
}
function loadDrumKitBundle(yaml, files, directoryName) {
  var _a, _b, _c, _d;
  const baseNoteRaw = (_a = yaml == null ? void 0 : yaml.baseNote) != null ? _a : "C2";
  const baseNote = typeof baseNoteRaw === "number" ? baseNoteRaw : resolveKey(baseNoteRaw);
  const name = (_b = yaml == null ? void 0 : yaml.name) != null ? _b : directoryName;
  const description = yaml == null ? void 0 : yaml.description;
  const sampleRate = (_c = yaml == null ? void 0 : yaml.sampleRate) != null ? _c : 15e3;
  let kits;
  let source;
  let slices;
  if ((yaml == null ? void 0 : yaml.source) && (yaml == null ? void 0 : yaml.slices) && yaml.slices.length > 0) {
    source = yaml.source;
    slices = yaml.slices;
    const kitCount = Math.ceil(slices.length / 4);
    kits = [];
    for (let kitIndex = 0; kitIndex < kitCount; kitIndex++) {
      const startIdx = kitIndex * 4;
      const kitSlices = slices.slice(startIdx, startIdx + 4);
      const samples = {};
      for (let i = 0; i < kitSlices.length; i++) {
        const slice = kitSlices[i];
        if (!slice) continue;
        const paddedKit = String(kitIndex + 1).padStart(2, "0");
        const filename = `${paddedKit} ${slice.label.toUpperCase()}.wav`;
        switch (i) {
          case 0:
            samples.kick = filename;
            break;
          case 1:
            samples.snare = filename;
            break;
          case 2:
            samples.hhClosed = filename;
            break;
          case 3:
            samples.hhOpen = filename;
            break;
        }
      }
      kits.push({
        kitNumber: kitIndex + 1,
        samples,
        midiNotes: resolveMidiNotes(baseNote, kitIndex),
        isComplete: kitSlices.length === 4
      });
    }
  } else if ((yaml == null ? void 0 : yaml.kits) && yaml.kits.length > 0) {
    kits = yaml.kits.map((entry, index) => ({
      kitNumber: index + 1,
      samples: {
        kick: entry.samples.kick,
        snare: entry.samples.snare,
        hhClosed: entry.samples.hhClosed,
        hhOpen: entry.samples.hhOpen
      },
      midiNotes: resolveMidiNotes(baseNote, index),
      isComplete: true
      // YAML-specified kits are assumed complete
    }));
  } else {
    kits = parseDrumKitDirectory(files, baseNote);
  }
  const totalSamples = slices ? slices.length : kits.reduce(
    (sum, kit) => sum + countKitSamples(kit.samples),
    0
  );
  const allComplete = kits.every((kit) => kit.isComplete);
  return {
    name,
    description,
    sampleRate,
    baseNote,
    kits,
    totalSamples,
    allComplete,
    transpose: yaml == null ? void 0 : yaml.transpose,
    velocitySensitivity: (_d = yaml == null ? void 0 : yaml.velocitySensitivity) != null ? _d : 2,
    // Default to 2 (moderate sensitivity)
    source,
    slices
  };
}
function getAllSampleFilenames(bundle) {
  const filenames = [];
  for (const kit of bundle.kits) {
    if (kit.samples.kick) filenames.push(kit.samples.kick);
    if (kit.samples.snare) filenames.push(kit.samples.snare);
    if (kit.samples.hhClosed) filenames.push(kit.samples.hhClosed);
    if (kit.samples.hhOpen) filenames.push(kit.samples.hhOpen);
  }
  return filenames;
}

// src/sample-chopper/browser.ts
import {
  DEFAULT_DRUM_TYPES as DEFAULT_DRUM_TYPES2,
  DEFAULT_BASE_NOTE as DEFAULT_BASE_NOTE2,
  msToSamples,
  samplesToMs,
  calculateRms,
  calculatePeak,
  amplitudeToDb,
  dbToAmplitude,
  calculateRmsWindowed,
  findOnsetAboveThreshold,
  findSilenceStart,
  sliceByFixedInterval,
  sliceBySilence,
  trimSilence,
  sliceByTransient,
  refineOnsetPosition,
  sliceByManualRegions,
  createRegionsFromBoundaries,
  createRegionsFromTempo,
  sliceAudio as sliceAudio2,
  analyzeForSlicing as analyzeForSlicing2
} from "@audiocontrol/sample-chopper";

// src/sample-chopper/types.ts
import {
  DEFAULT_DRUM_TYPES,
  DEFAULT_BASE_NOTE
} from "@audiocontrol/sample-chopper";

// src/sample-chopper/chopper.ts
import { sliceAudio, analyzeForSlicing } from "@audiocontrol/sample-chopper";
function slicesToDrumKit(sliceResult, config) {
  var _a, _b, _c, _d;
  const baseNote = (_a = config.baseNote) != null ? _a : DEFAULT_BASE_NOTE;
  const drumTypes = (_b = config.drumTypes) != null ? _b : DEFAULT_DRUM_TYPES;
  const kits = [];
  const SAMPLES_PER_KIT = 4;
  for (let i = 0; i < sliceResult.slices.length; i += SAMPLES_PER_KIT) {
    const kitIndex = Math.floor(i / SAMPLES_PER_KIT);
    const kitSlices = sliceResult.slices.slice(i, i + SAMPLES_PER_KIT);
    const samples = {};
    const typeOrder = ["kick", "snare", "hhClosed", "hhOpen"];
    for (let j = 0; j < kitSlices.length; j++) {
      const slice = kitSlices[j];
      const drumType = typeOrder[j];
      const label = (_c = drumTypes[j % drumTypes.length]) != null ? _c : drumType;
      const filename = formatSampleFilename(kitIndex + 1, label);
      samples[drumType] = filename;
    }
    const midiNotes = {
      kick: baseNote + kitIndex * 4,
      snare: baseNote + kitIndex * 4 + 1,
      hhClosed: baseNote + kitIndex * 4 + 2,
      hhOpen: baseNote + kitIndex * 4 + 3
    };
    kits.push({
      kitNumber: kitIndex + 1,
      samples,
      midiNotes,
      isComplete: kitSlices.length === SAMPLES_PER_KIT
    });
  }
  return {
    name: config.name,
    sampleRate: config.sampleRate,
    baseNote,
    kits,
    totalSamples: sliceResult.slices.length,
    allComplete: kits.every((k) => k.isComplete),
    transpose: config.transpose,
    velocitySensitivity: (_d = config.velocitySensitivity) != null ? _d : 2
  };
}
function formatSampleFilename(kitNumber, drumType) {
  const paddedNumber = String(kitNumber).padStart(2, "0");
  const label = drumType.toUpperCase();
  return `${paddedNumber} ${label}.wav`;
}

// src/loop-detector/types.ts
var DEFAULT_SEARCH_CONFIG = {
  searchWindowMs: 100,
  startSearchWindowMs: 200,
  sustainStartMs: 50,
  correlationWindowMs: 34,
  topK: 10,
  weights: {
    ncc: 0.5,
    spectral: 0.35,
    slope: 0.15
  },
  excludeTrailingSilence: true,
  silenceThresholdDb: -40
};
var DEFAULT_SPLICE_CONFIG = {
  crossfadeLength: 32,
  mode: "linear"
};
var DEFAULT_TRANSIENT_CONFIG = {
  windowMs: 50,
  hopMs: 10,
  derivativeThreshold: 0.01,
  minSustainOffsetMs: 50,
  stableEnvelopeVarianceThreshold: 0.02,
  maxSustainPositionRatio: 0.25
};
var HARDWARE_CONSTRAINTS = {
  /**
   * Minimum loop length in samples.
   * Shorter loops cause hardware instability.
   */
  MIN_LOOP_LENGTH: 32,
  /**
   * Maximum sample length for S-550 (in samples at base rate).
   */
  MAX_SAMPLE_LENGTH_S550: 524288,
  /**
   * Maximum sample length for S-330 (in samples at base rate).
   */
  MAX_SAMPLE_LENGTH_S330: 262144,
  /**
   * All loop point indices must be even (2-byte boundary).
   */
  WORD_ALIGNMENT: 2
};

// src/loop-detector/zero-crossing-detector.ts
var MAX_SAMPLE_VALUE = 32768;
var MAX_SLOPE = 2 * MAX_SAMPLE_VALUE;
function snapToWordBoundary(index) {
  return Math.floor(index / HARDWARE_CONSTRAINTS.WORD_ALIGNMENT) * HARDWARE_CONSTRAINTS.WORD_ALIGNMENT;
}
function detectZeroCrossings(samples, startIndex, endIndex) {
  const crossings = [];
  const start = Math.max(1, startIndex);
  const end = Math.min(samples.length, endIndex);
  for (let i = start; i < end; i++) {
    const prev = samples[i - 1];
    const curr = samples[i];
    let polarity = null;
    if (prev < 0 && curr >= 0) {
      polarity = "positive";
    } else if (prev >= 0 && curr < 0) {
      polarity = "negative";
    }
    if (polarity !== null) {
      const slope = (curr - prev) / MAX_SLOPE;
      const alignedIndex = snapToWordBoundary(i);
      if (crossings.length === 0 || crossings[crossings.length - 1].index !== alignedIndex) {
        crossings.push({
          index: alignedIndex,
          polarity,
          slope
        });
      }
    }
  }
  return crossings;
}
function filterByPolarity(crossings, polarity) {
  return crossings.filter((c) => c.polarity === polarity);
}
function matchBySlope(crossings, targetSlope, tolerance) {
  return crossings.filter((c) => Math.abs(c.slope - targetSlope) <= tolerance);
}
function findMatchingCrossings(crossings, reference, slopeTolerance) {
  return crossings.filter(
    (c) => c.polarity === reference.polarity && Math.abs(c.slope - reference.slope) <= slopeTolerance
  );
}
function calculateSlopeScore(crossing1, crossing2) {
  const maxDiff = 2;
  const diff = Math.abs(crossing1.slope - crossing2.slope);
  return 1 - diff / maxDiff;
}
function generateCandidatePairs(startCrossings, endCrossings, minLoopLength = HARDWARE_CONSTRAINTS.MIN_LOOP_LENGTH, slopeTolerance = null) {
  const pairs = [];
  for (const endCrossing of endCrossings) {
    let matchingStarts;
    if (slopeTolerance !== null) {
      matchingStarts = findMatchingCrossings(startCrossings, endCrossing, slopeTolerance);
    } else {
      matchingStarts = filterByPolarity(startCrossings, endCrossing.polarity);
    }
    for (const startCrossing of matchingStarts) {
      const loopLength = endCrossing.index - startCrossing.index;
      if (loopLength >= minLoopLength) {
        pairs.push({
          loopStart: startCrossing.index,
          loopEnd: endCrossing.index,
          startCrossing,
          endCrossing
        });
      }
    }
  }
  return pairs;
}

// src/sample-chopper/audio-utils.ts
import {
  msToSamples as msToSamples2,
  samplesToMs as samplesToMs2,
  calculateRms as calculateRms2,
  calculatePeak as calculatePeak2,
  amplitudeToDb as amplitudeToDb2,
  dbToAmplitude as dbToAmplitude2,
  calculateRmsWindowed as calculateRmsWindowed2,
  findOnsetAboveThreshold as findOnsetAboveThreshold2,
  findSilenceStart as findSilenceStart2
} from "@audiocontrol/sample-chopper";

// src/loop-detector/transient-excluder.ts
function findSustainStart(samples, sampleRate, config = {}) {
  const cfg = __spreadValues(__spreadValues({}, DEFAULT_TRANSIENT_CONFIG), config);
  const windowSizeSamples = msToSamples2(cfg.windowMs, sampleRate);
  const hopSizeSamples = msToSamples2(cfg.hopMs, sampleRate);
  const minSustainOffsetSamples = msToSamples2(cfg.minSustainOffsetMs, sampleRate);
  const effectiveWindowSize = Math.max(windowSizeSamples, 1);
  const effectiveHopSize = Math.max(hopSizeSamples, 1);
  const rmsEnvelope = calculateRmsWindowed2(samples, effectiveWindowSize, effectiveHopSize);
  if (rmsEnvelope.length < 2) {
    return Math.min(minSustainOffsetSamples, samples.length);
  }
  const peakRms = Math.max(...rmsEnvelope);
  if (peakRms === 0) {
    return Math.min(minSustainOffsetSamples, samples.length);
  }
  const envelopeVariance = calculateEnvelopeVariance(rmsEnvelope);
  if (envelopeVariance < cfg.stableEnvelopeVarianceThreshold) {
    return Math.min(minSustainOffsetSamples, samples.length);
  }
  const derivatives = calculateEnvelopeDerivative(rmsEnvelope, peakRms);
  const sustainFrameIndex = findStabilizationPoint(derivatives, cfg.derivativeThreshold);
  const sustainSampleIndex = sustainFrameIndex * effectiveHopSize;
  const isDecaying = isDecayingEnvelope(rmsEnvelope);
  let finalSustainIndex = sustainSampleIndex;
  if (!isDecaying) {
    const maxSustainPosition = Math.floor(samples.length * cfg.maxSustainPositionRatio);
    finalSustainIndex = Math.min(sustainSampleIndex, maxSustainPosition);
  }
  return Math.max(finalSustainIndex, minSustainOffsetSamples);
}
function calculateEnvelopeDerivative(envelope, peakRms) {
  const derivatives = [];
  for (let i = 1; i < envelope.length; i++) {
    const derivative = (envelope[i] - envelope[i - 1]) / peakRms;
    derivatives.push(derivative);
  }
  return derivatives;
}
function calculateEnvelopeVariance(envelope) {
  if (envelope.length < 2) return 0;
  const mean = envelope.reduce((sum, val) => sum + val, 0) / envelope.length;
  if (mean === 0) return 0;
  const variance = envelope.reduce((sum, val) => {
    const diff = val - mean;
    return sum + diff * diff;
  }, 0) / envelope.length;
  return variance / (mean * mean);
}
function isDecayingEnvelope(envelope) {
  if (envelope.length < 10) return false;
  const quarterLength = Math.floor(envelope.length / 4);
  if (quarterLength < 2) return false;
  let firstQuarterSum = 0;
  for (let i = 0; i < quarterLength; i++) {
    firstQuarterSum += envelope[i];
  }
  const firstQuarterAvg = firstQuarterSum / quarterLength;
  const middleStart = Math.floor(envelope.length * 0.4);
  const middleEnd = Math.floor(envelope.length * 0.6);
  const middleLength = middleEnd - middleStart;
  let middleSum = 0;
  for (let i = middleStart; i < middleEnd; i++) {
    middleSum += envelope[i];
  }
  const middleAvg = middleLength > 0 ? middleSum / middleLength : 0;
  let lastQuarterSum = 0;
  const lastQuarterStart = envelope.length - quarterLength;
  for (let i = lastQuarterStart; i < envelope.length; i++) {
    lastQuarterSum += envelope[i];
  }
  const lastQuarterAvg = lastQuarterSum / quarterLength;
  if (firstQuarterAvg === 0) return false;
  const middleToFirstRatio = middleAvg / firstQuarterAvg;
  const lastToFirstRatio = lastQuarterAvg / firstQuarterAvg;
  const hasDecayInMiddle = middleToFirstRatio < 0.7;
  const hasDecayAtEnd = lastToFirstRatio < 0.5;
  return hasDecayInMiddle && hasDecayAtEnd;
}
function findStabilizationPoint(derivatives, threshold) {
  const minStableFrames = 3;
  for (let i = 0; i < derivatives.length - minStableFrames; i++) {
    let stable = true;
    for (let j = 0; j < minStableFrames; j++) {
      if (Math.abs(derivatives[i + j]) > threshold) {
        stable = false;
        break;
      }
    }
    if (stable) {
      return i + 1;
    }
  }
  return findMinDerivativeAfterPeak(derivatives) + 1;
}
function findMinDerivativeAfterPeak(derivatives) {
  var _a, _b;
  let peakIndex = 0;
  let peakValue = (_a = derivatives[0]) != null ? _a : 0;
  for (let i = 1; i < derivatives.length; i++) {
    if (derivatives[i] > peakValue) {
      peakValue = derivatives[i];
      peakIndex = i;
    }
  }
  let minIndex = peakIndex;
  let minValue = Math.abs((_b = derivatives[peakIndex]) != null ? _b : 0);
  for (let i = peakIndex + 1; i < derivatives.length; i++) {
    const absValue = Math.abs(derivatives[i]);
    if (absValue < minValue) {
      minValue = absValue;
      minIndex = i;
    }
  }
  return minIndex;
}
function analyzeAttack(samples, sampleRate, config = {}) {
  const cfg = __spreadValues(__spreadValues({}, DEFAULT_TRANSIENT_CONFIG), config);
  const windowSizeSamples = msToSamples2(cfg.windowMs, sampleRate);
  const hopSizeSamples = msToSamples2(cfg.hopMs, sampleRate);
  const effectiveWindowSize = Math.max(windowSizeSamples, 1);
  const effectiveHopSize = Math.max(hopSizeSamples, 1);
  const rmsEnvelope = calculateRmsWindowed2(samples, effectiveWindowSize, effectiveHopSize);
  if (rmsEnvelope.length === 0) {
    return {
      peakIndex: 0,
      peakRms: 0,
      sustainStartIndex: 0,
      attackDurationMs: 0,
      hasDetectedAttack: false
    };
  }
  let peakFrameIndex = 0;
  let peakRms = rmsEnvelope[0];
  for (let i = 1; i < rmsEnvelope.length; i++) {
    if (rmsEnvelope[i] > peakRms) {
      peakRms = rmsEnvelope[i];
      peakFrameIndex = i;
    }
  }
  const sustainStartIndex = findSustainStart(samples, sampleRate, config);
  const peakSampleIndex = peakFrameIndex * effectiveHopSize;
  const attackDurationMs = peakSampleIndex / sampleRate * 1e3;
  return {
    peakIndex: peakSampleIndex,
    peakRms,
    sustainStartIndex,
    attackDurationMs,
    hasDetectedAttack: peakSampleIndex > 0
  };
}
function findSustainEnd(samples, sampleRate, sustainStart, config = {}) {
  const cfg = __spreadValues(__spreadValues({}, DEFAULT_TRANSIENT_CONFIG), config);
  const windowSizeSamples = msToSamples2(cfg.windowMs, sampleRate);
  const hopSizeSamples = msToSamples2(cfg.hopMs, sampleRate);
  const effectiveWindowSize = Math.max(windowSizeSamples, 1);
  const effectiveHopSize = Math.max(hopSizeSamples, 1);
  const rmsEnvelope = calculateRmsWindowed2(samples, effectiveWindowSize, effectiveHopSize);
  if (rmsEnvelope.length < 10) {
    return samples.length;
  }
  const startFrame = Math.floor(rmsEnvelope.length * 0.1);
  const endFrame = Math.floor(rmsEnvelope.length * 0.5);
  if (endFrame <= startFrame) {
    return samples.length;
  }
  let sustainedSum = 0;
  for (let i = startFrame; i < endFrame; i++) {
    sustainedSum += rmsEnvelope[i];
  }
  const sustainedLevel = sustainedSum / (endFrame - startFrame);
  if (sustainedLevel === 0) {
    return samples.length;
  }
  const decayThreshold = sustainedLevel * 0.7;
  const scanStart = Math.floor(rmsEnvelope.length * 0.9);
  for (let i = scanStart; i >= startFrame; i--) {
    if (rmsEnvelope[i] >= decayThreshold) {
      const sustainEndFrame = Math.min(i + 5, rmsEnvelope.length - 1);
      return sustainEndFrame * effectiveHopSize;
    }
  }
  return samples.length;
}

// src/loop-detector/ncc-scorer.ts
function calculateNCC(samples, loopStart, loopEnd, windowSize) {
  const startWindowStart = loopStart;
  const startWindowEnd = loopStart + windowSize;
  const endWindowStart = loopEnd - windowSize;
  const endWindowEnd = loopEnd;
  if (startWindowStart < 0 || startWindowEnd > samples.length) {
    return 0;
  }
  if (endWindowStart < 0 || endWindowEnd > samples.length) {
    return 0;
  }
  if (windowSize <= 0) {
    return 0;
  }
  let sumAB = 0;
  let sumA2 = 0;
  let sumB2 = 0;
  for (let i = 0; i < windowSize; i++) {
    const a = samples[startWindowStart + i];
    const b = samples[endWindowStart + i];
    sumAB += a * b;
    sumA2 += a * a;
    sumB2 += b * b;
  }
  const denominator = Math.sqrt(sumA2 * sumB2);
  if (denominator === 0) {
    if (sumA2 === 0 && sumB2 === 0) {
      return 1;
    }
    return 0;
  }
  return sumAB / denominator;
}
function calculateZeroMeanNCC(samples, loopStart, loopEnd, windowSize) {
  const startWindowStart = loopStart;
  const startWindowEnd = loopStart + windowSize;
  const endWindowStart = loopEnd - windowSize;
  const endWindowEnd = loopEnd;
  if (startWindowStart < 0 || startWindowEnd > samples.length) {
    return 0;
  }
  if (endWindowStart < 0 || endWindowEnd > samples.length) {
    return 0;
  }
  if (windowSize <= 0) {
    return 0;
  }
  let sumA = 0;
  let sumB = 0;
  for (let i = 0; i < windowSize; i++) {
    sumA += samples[startWindowStart + i];
    sumB += samples[endWindowStart + i];
  }
  const meanA = sumA / windowSize;
  const meanB = sumB / windowSize;
  let sumAB = 0;
  let sumA2 = 0;
  let sumB2 = 0;
  for (let i = 0; i < windowSize; i++) {
    const a = samples[startWindowStart + i] - meanA;
    const b = samples[endWindowStart + i] - meanB;
    sumAB += a * b;
    sumA2 += a * a;
    sumB2 += b * b;
  }
  const denominator = Math.sqrt(sumA2 * sumB2);
  if (denominator === 0) {
    if (sumA2 === 0 && sumB2 === 0) {
      return 1;
    }
    return 0;
  }
  return sumAB / denominator;
}
function batchCalculateNCC(samples, candidates, windowSize) {
  const results = /* @__PURE__ */ new Map();
  for (const { loopStart, loopEnd } of candidates) {
    const key = `${loopStart},${loopEnd}`;
    const score = calculateNCC(samples, loopStart, loopEnd, windowSize);
    results.set(key, score);
  }
  return results;
}
function calculateOptimalWindowSize(sampleRate, minMs = 20, maxMs = 50, targetMs = 34) {
  const targetSamples = Math.round(targetMs * sampleRate / 1e3);
  const power = Math.round(Math.log2(targetSamples));
  let windowSize = Math.pow(2, power);
  const minSamples = Math.round(minMs * sampleRate / 1e3);
  const maxSamples = Math.round(maxMs * sampleRate / 1e3);
  windowSize = Math.max(minSamples, Math.min(maxSamples, windowSize));
  return windowSize;
}
function normalizeNCCScore(ncc) {
  return (ncc + 1) / 2;
}

// src/loop-detector/spectral-scorer.ts
import FFT from "fft.js";
var fftCache = /* @__PURE__ */ new Map();
function getFFT(size) {
  let fft = fftCache.get(size);
  if (!fft) {
    fft = new FFT(size);
    fftCache.set(size, fft);
  }
  return fft;
}
function createHannWindow(size) {
  const window = new Float64Array(size);
  for (let i = 0; i < size; i++) {
    window[i] = 0.5 * (1 - Math.cos(2 * Math.PI * i / (size - 1)));
  }
  return window;
}
var hannWindowCache = /* @__PURE__ */ new Map();
function getHannWindow(size) {
  let window = hannWindowCache.get(size);
  if (!window) {
    window = createHannWindow(size);
    hannWindowCache.set(size, window);
  }
  return window;
}
function computeLogMagnitudeSpectrum(samples, centerIndex, windowSize) {
  const halfWindow = Math.floor(windowSize / 2);
  const startIndex = centerIndex - halfWindow;
  const endIndex = startIndex + windowSize;
  const fft = getFFT(windowSize);
  const hannWindow = getHannWindow(windowSize);
  const input = new Float64Array(windowSize);
  for (let i = 0; i < windowSize; i++) {
    const sampleIndex = startIndex + i;
    if (sampleIndex < 0 || sampleIndex >= samples.length) {
      input[i] = 0;
    } else {
      const normalized = samples[sampleIndex] / 32768;
      input[i] = normalized * hannWindow[i];
    }
  }
  const complexOutput = fft.createComplexArray();
  fft.realTransform(complexOutput, input);
  const numBins = windowSize / 2 + 1;
  const logMagnitude = new Float32Array(numBins);
  const epsilon = 1e-10;
  for (let i = 0; i < numBins; i++) {
    const re = complexOutput[2 * i];
    const im = complexOutput[2 * i + 1];
    const magnitude = Math.sqrt(re * re + im * im);
    logMagnitude[i] = Math.log10(magnitude + epsilon);
  }
  return logMagnitude;
}
function calculateSpectralDistance(spectrum1, spectrum2) {
  if (spectrum1.length !== spectrum2.length) {
    throw new Error("Spectra must have the same length");
  }
  let sumSquaredDiff = 0;
  for (let i = 0; i < spectrum1.length; i++) {
    const diff = spectrum1[i] - spectrum2[i];
    sumSquaredDiff += diff * diff;
  }
  return Math.sqrt(sumSquaredDiff);
}
function scoreSpectralSimilarity(samples, loopStart, loopEnd, windowSize) {
  const spectrum1 = computeLogMagnitudeSpectrum(samples, loopStart, windowSize);
  const spectrum2 = computeLogMagnitudeSpectrum(samples, loopEnd, windowSize);
  const distance = calculateSpectralDistance(spectrum1, spectrum2);
  return normalizeSpectralDistance(distance);
}
function normalizeSpectralDistance(distance) {
  const decayConstant = 0.1;
  return Math.exp(-decayConstant * distance);
}
function batchCalculateSpectralSimilarity(samples, candidates, windowSize) {
  const results = /* @__PURE__ */ new Map();
  const spectrumCache = /* @__PURE__ */ new Map();
  const getSpectrum = (index) => {
    let spectrum = spectrumCache.get(index);
    if (!spectrum) {
      spectrum = computeLogMagnitudeSpectrum(samples, index, windowSize);
      spectrumCache.set(index, spectrum);
    }
    return spectrum;
  };
  for (const { loopStart, loopEnd } of candidates) {
    const spectrum1 = getSpectrum(loopStart);
    const spectrum2 = getSpectrum(loopEnd);
    const distance = calculateSpectralDistance(spectrum1, spectrum2);
    const similarity = normalizeSpectralDistance(distance);
    const key = `${loopStart},${loopEnd}`;
    results.set(key, similarity);
  }
  return results;
}
function calculateOptimalFFTSize(sampleRate, minFreqResolution = 50) {
  const minSize = sampleRate / minFreqResolution;
  const power = Math.ceil(Math.log2(minSize));
  const clampedPower = Math.max(9, Math.min(12, power));
  return Math.pow(2, clampedPower);
}

// src/loop-detector/candidate-scorer.ts
function scoreCandidate(samples, loopStart, loopEnd, startCrossing, endCrossing, sampleRate, config = DEFAULT_SEARCH_CONFIG) {
  const nccWindowSize = calculateOptimalWindowSize(sampleRate, 20, 50, config.correlationWindowMs);
  const fftWindowSize = calculateOptimalFFTSize(sampleRate);
  const nccScore = calculateNCC(samples, loopStart, loopEnd, nccWindowSize);
  const spectralScore = scoreSpectralSimilarity(samples, loopStart, loopEnd, fftWindowSize);
  const slopeScore = calculateSlopeScore(startCrossing, endCrossing);
  const compositeScore = calculateCompositeScore(nccScore, spectralScore, slopeScore, config.weights);
  return {
    loopStart,
    loopEnd,
    nccScore,
    spectralScore,
    slopeScore,
    compositeScore
  };
}
function calculateCompositeScore(nccScore, spectralScore, slopeScore, weights) {
  const normalizedNCC = (nccScore + 1) / 2;
  const score = weights.ncc * normalizedNCC + weights.spectral * spectralScore + weights.slope * slopeScore;
  return Math.max(0, Math.min(1, score));
}
function scoreCandidates(samples, candidatePairs, sampleRate, config = DEFAULT_SEARCH_CONFIG) {
  return candidatePairs.map(
    ({ loopStart, loopEnd, startCrossing, endCrossing }) => scoreCandidate(samples, loopStart, loopEnd, startCrossing, endCrossing, sampleRate, config)
  );
}
function rankCandidates(candidates, topK) {
  const sorted = [...candidates].sort((a, b) => b.compositeScore - a.compositeScore);
  return sorted.slice(0, topK);
}
function filterByThresholds(candidates, thresholds) {
  return candidates.filter((c) => {
    if (thresholds.minNCC !== void 0 && c.nccScore < thresholds.minNCC) {
      return false;
    }
    if (thresholds.minSpectral !== void 0 && c.spectralScore < thresholds.minSpectral) {
      return false;
    }
    if (thresholds.minSlope !== void 0 && c.slopeScore < thresholds.minSlope) {
      return false;
    }
    if (thresholds.minComposite !== void 0 && c.compositeScore < thresholds.minComposite) {
      return false;
    }
    return true;
  });
}
function deduplicateCandidates(candidates, minDistance) {
  const result = [];
  for (const candidate of candidates) {
    const tooClose = result.some(
      (selected) => Math.abs(candidate.loopStart - selected.loopStart) < minDistance && Math.abs(candidate.loopEnd - selected.loopEnd) < minDistance
    );
    if (!tooClose) {
      result.push(candidate);
    }
  }
  return result;
}

// src/loop-detector/loop-point-searcher.ts
var LoopDetectionError = class extends Error {
  constructor(message, reason) {
    super(message);
    this.reason = reason;
    this.name = "LoopDetectionError";
  }
};
function calculateLoopRegionRms(samples, loopStart, loopEnd, sampleRate) {
  const windowMs = 50;
  const windowSamples = msToSamples2(windowMs, sampleRate);
  const startRms = calculateRms2(samples, loopStart, Math.min(windowSamples, loopEnd - loopStart));
  const endRms = calculateRms2(samples, Math.max(loopStart, loopEnd - windowSamples), windowSamples);
  return (startRms + endRms) / 2;
}
function findAudioEnd(samples, sampleRate, thresholdDb, startPoint) {
  const windowSizeSamples = msToSamples2(5, sampleRate);
  const threshold = dbToAmplitude2(thresholdDb);
  const minAudioEnd = HARDWARE_CONSTRAINTS.MIN_LOOP_LENGTH * 2;
  for (let pos = startPoint - windowSizeSamples; pos >= minAudioEnd; pos -= windowSizeSamples) {
    const rms = calculateRms2(samples, pos, windowSizeSamples);
    if (rms >= threshold) {
      return Math.min(pos + windowSizeSamples, startPoint);
    }
  }
  return startPoint;
}
function searchLoopPoints(samples, sampleRate, targetEndPoint, config = {}, onProgress) {
  const cfg = __spreadValues(__spreadValues({}, DEFAULT_SEARCH_CONFIG), config);
  if (samples.length < HARDWARE_CONSTRAINTS.MIN_LOOP_LENGTH * 2) {
    throw new LoopDetectionError(
      "Sample is too short for loop detection.",
      "too_short"
    );
  }
  onProgress == null ? void 0 : onProgress(0, "Analyzing transient...");
  const sustainStart = findSustainStart(samples, sampleRate, {
    minSustainOffsetMs: cfg.sustainStartMs
  });
  const sustainRatio = sustainStart / samples.length;
  const isDecayingSample = sustainRatio > 0.5;
  onProgress == null ? void 0 : onProgress(10, "Finding zero crossings...");
  let effectiveEndPoint = targetEndPoint != null ? targetEndPoint : samples.length;
  const endSearchWindowSamples = msToSamples2(cfg.searchWindowMs, sampleRate);
  const startSearchWindowSamples = msToSamples2(cfg.startSearchWindowMs, sampleRate);
  const sustainEnd = findSustainEnd(samples, sampleRate, sustainStart, {
    minSustainOffsetMs: cfg.sustainStartMs
  });
  const minSustainRegion = startSearchWindowSamples + HARDWARE_CONSTRAINTS.MIN_LOOP_LENGTH + endSearchWindowSamples;
  const sustainRegionLength = sustainEnd - sustainStart;
  if (sustainRegionLength < minSustainRegion) {
    throw new LoopDetectionError(
      "No suitable loop points found. This appears to be a decaying sample without a sustained region.",
      "decaying_sample"
    );
  }
  if (sustainEnd < effectiveEndPoint) {
    effectiveEndPoint = sustainEnd;
    onProgress == null ? void 0 : onProgress(15, `Sustain ends at sample ${sustainEnd} (${(sustainEnd / sampleRate * 1e3).toFixed(0)}ms)`);
  }
  if (cfg.excludeTrailingSilence) {
    const audioEnd = findAudioEnd(samples, sampleRate, cfg.silenceThresholdDb, effectiveEndPoint);
    if (audioEnd < effectiveEndPoint) {
      const minRequiredLength = sustainStart + startSearchWindowSamples + HARDWARE_CONSTRAINTS.MIN_LOOP_LENGTH + endSearchWindowSamples;
      if (audioEnd >= minRequiredLength) {
        effectiveEndPoint = audioEnd;
        onProgress == null ? void 0 : onProgress(15, `Excluded trailing silence (audio ends at sample ${audioEnd})`);
      } else {
        onProgress == null ? void 0 : onProgress(15, "Trailing silence detected but preserving for valid search regions");
      }
    }
  }
  const startSearchStart = snapToWordBoundary(sustainStart);
  const startSearchEnd = snapToWordBoundary(
    Math.min(sustainStart + startSearchWindowSamples, effectiveEndPoint - HARDWARE_CONSTRAINTS.MIN_LOOP_LENGTH)
  );
  const endSearchStart = snapToWordBoundary(
    Math.max(startSearchEnd + HARDWARE_CONSTRAINTS.MIN_LOOP_LENGTH, effectiveEndPoint - endSearchWindowSamples)
  );
  const endSearchEnd = snapToWordBoundary(Math.min(samples.length, effectiveEndPoint));
  if (startSearchEnd <= startSearchStart || endSearchEnd <= endSearchStart) {
    return [];
  }
  const startCrossings = detectZeroCrossings(samples, startSearchStart, startSearchEnd);
  const endCrossings = detectZeroCrossings(samples, endSearchStart, endSearchEnd);
  onProgress == null ? void 0 : onProgress(30, `Found ${startCrossings.length} start and ${endCrossings.length} end crossings`);
  if (startCrossings.length === 0 || endCrossings.length === 0) {
    return [];
  }
  onProgress == null ? void 0 : onProgress(40, "Generating candidate pairs...");
  const totalPairs = startCrossings.length * endCrossings.length;
  const slopeTolerance = totalPairs > 1e3 ? 0.3 : null;
  const candidatePairs = generateCandidatePairs(
    startCrossings,
    endCrossings,
    HARDWARE_CONSTRAINTS.MIN_LOOP_LENGTH,
    slopeTolerance
  );
  onProgress == null ? void 0 : onProgress(50, `Generated ${candidatePairs.length} candidate pairs`);
  if (candidatePairs.length === 0) {
    return [];
  }
  onProgress == null ? void 0 : onProgress(60, "Scoring candidates...");
  const maxCandidatesToScore = 500;
  let pairsToScore = candidatePairs;
  if (candidatePairs.length > maxCandidatesToScore) {
    pairsToScore = sampleCandidates(candidatePairs, maxCandidatesToScore);
  }
  const scoredCandidates = scoreCandidates(samples, pairsToScore, sampleRate, cfg);
  onProgress == null ? void 0 : onProgress(80, "Ranking candidates...");
  const ranked = rankCandidates(scoredCandidates, cfg.topK * 3);
  const deduplicationDistance = Math.min(100, msToSamples2(5, sampleRate));
  const deduplicated = deduplicateCandidates(ranked, deduplicationDistance);
  const silenceThreshold = dbToAmplitude2(cfg.silenceThresholdDb);
  const usableCandidates = deduplicated.filter((candidate) => {
    const loopRms = calculateLoopRegionRms(samples, candidate.loopStart, candidate.loopEnd, sampleRate);
    return loopRms >= silenceThreshold;
  });
  if (usableCandidates.length === 0) {
    if (isDecayingSample) {
      throw new LoopDetectionError(
        "No suitable loop points found. This appears to be a decaying sample without a sustained region.",
        "decaying_sample"
      );
    } else if (deduplicated.length > 0) {
      throw new LoopDetectionError(
        "No suitable loop points found. All candidate regions are too quiet for a usable loop.",
        "no_usable_candidates"
      );
    } else {
      throw new LoopDetectionError(
        "No suitable loop points found in this sample.",
        "no_usable_candidates"
      );
    }
  }
  const topK = usableCandidates.slice(0, cfg.topK);
  onProgress == null ? void 0 : onProgress(100, `Found ${topK.length} candidates`);
  return topK;
}
function sampleCandidates(candidates, count) {
  if (candidates.length <= count) {
    return candidates;
  }
  const step = candidates.length / count;
  const result = [];
  for (let i = 0; i < count; i++) {
    const index = Math.floor(i * step);
    result.push(candidates[index]);
  }
  return result;
}
function quickSearchLoopPoints(samples, sampleRate, targetEndPoint, topK = 5) {
  const config = {
    searchWindowMs: 50,
    topK,
    // Adjust weights to use only NCC and slope
    weights: {
      ncc: 0.85,
      spectral: 0,
      slope: 0.15
    }
  };
  return searchLoopPoints(samples, sampleRate, targetEndPoint, config);
}
function validateCandidate(candidate, samples) {
  if (candidate.loopStart % HARDWARE_CONSTRAINTS.WORD_ALIGNMENT !== 0) {
    return false;
  }
  if (candidate.loopEnd % HARDWARE_CONSTRAINTS.WORD_ALIGNMENT !== 0) {
    return false;
  }
  if (candidate.loopStart < 0 || candidate.loopStart >= samples.length) {
    return false;
  }
  if (candidate.loopEnd < 0 || candidate.loopEnd > samples.length) {
    return false;
  }
  if (candidate.loopEnd - candidate.loopStart < HARDWARE_CONSTRAINTS.MIN_LOOP_LENGTH) {
    return false;
  }
  if (candidate.loopStart >= candidate.loopEnd) {
    return false;
  }
  return true;
}
function search(samples, sampleRate, targetEndPoint, options = {}) {
  var _a;
  if (options.quick) {
    return quickSearchLoopPoints(samples, sampleRate, targetEndPoint, (_a = options.config) == null ? void 0 : _a.topK);
  }
  return searchLoopPoints(samples, sampleRate, targetEndPoint, options.config, options.onProgress);
}

// src/loop-detector/splice-smoother.ts
function applyCrossfade(samples, loopStart, loopEnd, config = {}) {
  const cfg = __spreadValues(__spreadValues({}, DEFAULT_SPLICE_CONFIG), config);
  const loopLength = loopEnd - loopStart;
  if (loopLength < HARDWARE_CONSTRAINTS.MIN_LOOP_LENGTH) {
    throw new Error(
      `Loop length ${loopLength} is less than minimum ${HARDWARE_CONSTRAINTS.MIN_LOOP_LENGTH}`
    );
  }
  const maxCrossfadeLength = Math.floor(loopLength / 2);
  const effectiveCrossfadeLength = Math.min(cfg.crossfadeLength, maxCrossfadeLength);
  const minCrossfadeLength = 8;
  if (effectiveCrossfadeLength < minCrossfadeLength) {
    return samples;
  }
  if (cfg.mode === "equal-power") {
    return applyEqualPowerCrossfade(samples, loopStart, loopEnd, effectiveCrossfadeLength);
  } else {
    return applyLinearCrossfade(samples, loopStart, loopEnd, effectiveCrossfadeLength);
  }
}
function applyLinearCrossfade(samples, loopStart, loopEnd, crossfadeLength) {
  for (let i = 0; i < crossfadeLength; i++) {
    const alpha = i / crossfadeLength;
    const endIndex = loopEnd - crossfadeLength + i;
    const startIndex = loopStart + i;
    const endSample = samples[endIndex];
    const startSample = samples[startIndex];
    const blended = Math.round((1 - alpha) * endSample + alpha * startSample);
    samples[endIndex] = clamp16Bit(blended);
  }
  return samples;
}
function applyEqualPowerCrossfade(samples, loopStart, loopEnd, crossfadeLength) {
  const halfPi = Math.PI / 2;
  for (let i = 0; i < crossfadeLength; i++) {
    const angle = i / crossfadeLength * halfPi;
    const alphaOut = Math.cos(angle);
    const alphaIn = Math.sin(angle);
    const endIndex = loopEnd - crossfadeLength + i;
    const startIndex = loopStart + i;
    const endSample = samples[endIndex];
    const startSample = samples[startIndex];
    const blended = Math.round(alphaOut * endSample + alphaIn * startSample);
    samples[endIndex] = clamp16Bit(blended);
  }
  return samples;
}
function clamp16Bit(value) {
  return Math.max(-32768, Math.min(32767, value));
}
function createSmoothedCopy(samples, loopStart, loopEnd, config = {}) {
  const copy = new Int16Array(samples.length);
  copy.set(samples);
  return applyCrossfade(copy, loopStart, loopEnd, config);
}
function calculateOptimalCrossfadeLength(sampleRate, loopLength, targetMs = 1) {
  const targetSamples = Math.round(targetMs * sampleRate / 1e3);
  const minLength = 8;
  const maxLength = Math.floor(loopLength / 2);
  const defaultLength = 32;
  const preferred = targetSamples > 0 ? targetSamples : defaultLength;
  return Math.max(minLength, Math.min(maxLength, preferred));
}
function analyzeDiscontinuity(samples, loopStart, loopEnd) {
  var _a, _b, _c, _d, _e, _f;
  const endValue = (_a = samples[loopEnd - 1]) != null ? _a : 0;
  const startValue = (_b = samples[loopStart]) != null ? _b : 0;
  const amplitudeStep = Math.abs(endValue - startValue);
  const normalizedStep = amplitudeStep / 32768;
  const endSlope = ((_c = samples[loopEnd - 1]) != null ? _c : 0) - ((_d = samples[loopEnd - 2]) != null ? _d : 0);
  const startSlope = ((_e = samples[loopStart + 1]) != null ? _e : 0) - ((_f = samples[loopStart]) != null ? _f : 0);
  const slopeDiff = Math.abs(endSlope - startSlope);
  const normalizedSlopeDiff = slopeDiff / 65536;
  let recommendedCrossfadeLength;
  if (normalizedStep < 0.01 && normalizedSlopeDiff < 0.01) {
    recommendedCrossfadeLength = 8;
  } else if (normalizedStep < 0.05 && normalizedSlopeDiff < 0.05) {
    recommendedCrossfadeLength = 16;
  } else if (normalizedStep < 0.1 && normalizedSlopeDiff < 0.1) {
    recommendedCrossfadeLength = 32;
  } else {
    recommendedCrossfadeLength = 64;
  }
  return {
    amplitudeStep,
    normalizedAmplitudeStep: normalizedStep,
    slopeDifference: slopeDiff,
    normalizedSlopeDifference: normalizedSlopeDiff,
    needsSmoothing: normalizedStep > 0.01 || normalizedSlopeDiff > 0.01,
    recommendedCrossfadeLength
  };
}

// src/browser-library-connection.ts
var IDB_NAME = "audiocontrol-library-handles";
var IDB_STORE = "handles";
function openHandleDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(IDB_NAME, 1);
    req.onupgradeneeded = () => {
      req.result.createObjectStore(IDB_STORE);
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}
function saveHandleToIDB(key, handle) {
  return __async(this, null, function* () {
    const db = yield openHandleDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(IDB_STORE, "readwrite");
      tx.objectStore(IDB_STORE).put(handle, key);
      tx.oncomplete = () => {
        db.close();
        resolve();
      };
      tx.onerror = () => {
        db.close();
        reject(tx.error);
      };
    });
  });
}
function loadHandleFromIDB(key) {
  return __async(this, null, function* () {
    const db = yield openHandleDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(IDB_STORE, "readonly");
      const req = tx.objectStore(IDB_STORE).get(key);
      req.onsuccess = () => {
        var _a;
        db.close();
        resolve((_a = req.result) != null ? _a : null);
      };
      req.onerror = () => {
        db.close();
        reject(req.error);
      };
    });
  });
}
function removeHandleFromIDB(key) {
  return __async(this, null, function* () {
    const db = yield openHandleDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(IDB_STORE, "readwrite");
      tx.objectStore(IDB_STORE).delete(key);
      tx.oncomplete = () => {
        db.close();
        resolve();
      };
      tx.onerror = () => {
        db.close();
        reject(tx.error);
      };
    });
  });
}
var BrowserLibraryConnection = class {
  constructor(options) {
    this.cachedHandle = null;
    var _a, _b;
    this.pickerId = (_a = options == null ? void 0 : options.pickerId) != null ? _a : "audiocontrol-library";
    this.startIn = (_b = options == null ? void 0 : options.startIn) != null ? _b : "documents";
  }
  connect() {
    return __async(this, null, function* () {
      if (!("showDirectoryPicker" in globalThis)) return false;
      try {
        const handle = yield globalThis.showDirectoryPicker({
          id: this.pickerId,
          mode: "readwrite",
          startIn: this.startIn
        });
        this.cachedHandle = handle;
        yield saveHandleToIDB(this.pickerId, handle).catch(() => {
        });
        return true;
      } catch (err) {
        if (err instanceof DOMException && err.name === "AbortError") return false;
        throw err;
      }
    });
  }
  /**
   * Try to restore a previously selected directory from IndexedDB.
   * Returns true if the handle was restored and permission was granted.
   * The browser may show a permission prompt on the first restore.
   */
  tryRestore() {
    return __async(this, null, function* () {
      try {
        const handle = yield loadHandleFromIDB(this.pickerId);
        if (!handle) return false;
        const h = handle;
        const perm = yield h.queryPermission({ mode: "readwrite" });
        if (perm === "granted") {
          this.cachedHandle = handle;
          return true;
        }
        const req = yield h.requestPermission({ mode: "readwrite" });
        if (req === "granted") {
          this.cachedHandle = handle;
          return true;
        }
        yield removeHandleFromIDB(this.pickerId).catch(() => {
        });
        return false;
      } catch (e) {
        return false;
      }
    });
  }
  isConnected() {
    return this.cachedHandle !== null;
  }
  getRoot() {
    if (!this.cachedHandle) {
      throw new Error("Library not connected \u2014 call connect() first");
    }
    return this.cachedHandle;
  }
  /**
   * Re-verify permissions on the cached handle. Returns false if
   * the user denies or the handle has been invalidated.
   */
  verifyPermission() {
    return __async(this, null, function* () {
      if (!this.cachedHandle) return false;
      try {
        const handle = this.cachedHandle;
        if (typeof handle.queryPermission !== "function") return true;
        const perm = yield handle.queryPermission({ mode: "readwrite" });
        if (perm === "granted") return true;
        const req = yield handle.requestPermission({ mode: "readwrite" });
        if (req === "granted") return true;
      } catch (e) {
      }
      this.cachedHandle = null;
      return false;
    });
  }
};

// src/opfs-library-connection.ts
var OPFSLibraryConnection = class {
  constructor() {
    this.opfsRoot = null;
  }
  /**
   * Connect to the OPFS-backed library.
   *
   * Gets the OPFS root via `navigator.storage.getDirectory()` and ensures
   * the `library` directory exists inside it.
   *
   * @returns true if connection succeeded, false if OPFS is not available
   */
  connect() {
    return __async(this, null, function* () {
      if (!("storage" in navigator) || typeof navigator.storage.getDirectory !== "function") {
        return false;
      }
      try {
        const opfsRoot = yield navigator.storage.getDirectory();
        yield opfsRoot.getDirectoryHandle("library", { create: true });
        this.opfsRoot = opfsRoot;
        return true;
      } catch (e) {
        return false;
      }
    });
  }
  /**
   * Check if a library connection is established.
   */
  isConnected() {
    return this.opfsRoot !== null;
  }
  /**
   * Get the storage root directory handle.
   *
   * @returns The OPFS root (parent of library/)
   * @throws Error if not connected
   */
  getRoot() {
    if (!this.opfsRoot) {
      throw new Error("Library not connected - call connect() first");
    }
    return this.opfsRoot;
  }
};

// src/cached-storage.ts
function normalizePath(path) {
  return path.toLowerCase().replace(/\\/g, "/").replace(/\/+$/, "").replace(/^\/+/, "");
}
function joinPath(base, name) {
  const normalizedBase = normalizePath(base);
  const normalizedName = normalizePath(name);
  if (!normalizedBase) return normalizedName;
  return `${normalizedBase}/${normalizedName}`;
}
var StorageCache = class {
  constructor() {
    /** Cached directory listings: path -> StorageEntry[] */
    this.entries = /* @__PURE__ */ new Map();
    /** Cached directory handles: path -> CachedStorageDirectoryHandle */
    this.directories = /* @__PURE__ */ new Map();
    /** Cached file handles: path -> CachedStorageFileHandle */
    this.files = /* @__PURE__ */ new Map();
    /** Cached file contents: path -> StorageFile */
    this.content = /* @__PURE__ */ new Map();
    // Metrics tracking
    this._entriesHits = 0;
    this._entriesMisses = 0;
    this._entriesHitTimeMs = 0;
    this._entriesMissTimeMs = 0;
    this._directoriesHits = 0;
    this._directoriesMisses = 0;
    this._directoriesHitTimeMs = 0;
    this._directoriesMissTimeMs = 0;
    this._filesHits = 0;
    this._filesMisses = 0;
    this._filesHitTimeMs = 0;
    this._filesMissTimeMs = 0;
    this._contentHits = 0;
    this._contentMisses = 0;
    this._contentHitTimeMs = 0;
    this._contentMissTimeMs = 0;
    this._invalidations = 0;
    this._clears = 0;
  }
  /** Record a cache hit for the entries cache */
  recordEntriesHit(durationMs) {
    this._entriesHits++;
    this._entriesHitTimeMs += durationMs;
  }
  /** Record a cache miss for the entries cache */
  recordEntriesMiss(durationMs) {
    this._entriesMisses++;
    this._entriesMissTimeMs += durationMs;
  }
  /** Record a cache hit for the directories cache */
  recordDirectoriesHit(durationMs) {
    this._directoriesHits++;
    this._directoriesHitTimeMs += durationMs;
  }
  /** Record a cache miss for the directories cache */
  recordDirectoriesMiss(durationMs) {
    this._directoriesMisses++;
    this._directoriesMissTimeMs += durationMs;
  }
  /** Record a cache hit for the files cache */
  recordFilesHit(durationMs) {
    this._filesHits++;
    this._filesHitTimeMs += durationMs;
  }
  /** Record a cache miss for the files cache */
  recordFilesMiss(durationMs) {
    this._filesMisses++;
    this._filesMissTimeMs += durationMs;
  }
  /** Record a cache hit for the content cache */
  recordContentHit(durationMs) {
    this._contentHits++;
    this._contentHitTimeMs += durationMs;
  }
  /** Record a cache miss for the content cache */
  recordContentMiss(durationMs) {
    this._contentMisses++;
    this._contentMissTimeMs += durationMs;
  }
  /**
   * Get current cache metrics.
   */
  getMetrics() {
    const totalHits = this._entriesHits + this._directoriesHits + this._filesHits + this._contentHits;
    const totalMisses = this._entriesMisses + this._directoriesMisses + this._filesMisses + this._contentMisses;
    const total = totalHits + totalMisses;
    const totalHitTimeMs = this._entriesHitTimeMs + this._directoriesHitTimeMs + this._filesHitTimeMs + this._contentHitTimeMs;
    const totalMissTimeMs = this._entriesMissTimeMs + this._directoriesMissTimeMs + this._filesMissTimeMs + this._contentMissTimeMs;
    return {
      entries: {
        hits: this._entriesHits,
        misses: this._entriesMisses,
        size: this.entries.size,
        hitTimeMs: this._entriesHitTimeMs,
        missTimeMs: this._entriesMissTimeMs
      },
      directories: {
        hits: this._directoriesHits,
        misses: this._directoriesMisses,
        size: this.directories.size,
        hitTimeMs: this._directoriesHitTimeMs,
        missTimeMs: this._directoriesMissTimeMs
      },
      files: {
        hits: this._filesHits,
        misses: this._filesMisses,
        size: this.files.size,
        hitTimeMs: this._filesHitTimeMs,
        missTimeMs: this._filesMissTimeMs
      },
      content: {
        hits: this._contentHits,
        misses: this._contentMisses,
        size: this.content.size,
        hitTimeMs: this._contentHitTimeMs,
        missTimeMs: this._contentMissTimeMs
      },
      totalHits,
      totalMisses,
      hitRate: total > 0 ? totalHits / total : 0,
      totalHitTimeMs,
      totalMissTimeMs,
      avgHitTimeMs: totalHits > 0 ? totalHitTimeMs / totalHits : 0,
      avgMissTimeMs: totalMisses > 0 ? totalMissTimeMs / totalMisses : 0,
      invalidations: this._invalidations,
      clears: this._clears
    };
  }
  /**
   * Reset all metrics counters to zero.
   */
  resetMetrics() {
    this._entriesHits = 0;
    this._entriesMisses = 0;
    this._entriesHitTimeMs = 0;
    this._entriesMissTimeMs = 0;
    this._directoriesHits = 0;
    this._directoriesMisses = 0;
    this._directoriesHitTimeMs = 0;
    this._directoriesMissTimeMs = 0;
    this._filesHits = 0;
    this._filesMisses = 0;
    this._filesHitTimeMs = 0;
    this._filesMissTimeMs = 0;
    this._contentHits = 0;
    this._contentMisses = 0;
    this._contentHitTimeMs = 0;
    this._contentMissTimeMs = 0;
    this._invalidations = 0;
    this._clears = 0;
  }
  /**
   * Invalidate a directory's cached entries and all children under that path.
   */
  invalidate(path) {
    const normalizedPath = normalizePath(path);
    const prefix = normalizedPath ? `${normalizedPath}/` : "";
    this.entries.delete(normalizedPath);
    this.directories.delete(normalizedPath);
    this.files.delete(normalizedPath);
    this.content.delete(normalizedPath);
    for (const key of this.entries.keys()) {
      if (key.startsWith(prefix)) {
        this.entries.delete(key);
      }
    }
    for (const key of this.directories.keys()) {
      if (key.startsWith(prefix)) {
        this.directories.delete(key);
      }
    }
    for (const key of this.files.keys()) {
      if (key.startsWith(prefix)) {
        this.files.delete(key);
      }
    }
    for (const key of this.content.keys()) {
      if (key.startsWith(prefix)) {
        this.content.delete(key);
      }
    }
    this._invalidations++;
  }
  /**
   * Invalidate a single file's content cache.
   */
  invalidateFile(path) {
    const normalizedPath = normalizePath(path);
    this.content.delete(normalizedPath);
    this.files.delete(normalizedPath);
  }
  /**
   * Clear all caches.
   */
  clear() {
    this.entries.clear();
    this.directories.clear();
    this.files.clear();
    this.content.clear();
    this._clears++;
  }
};
var CachedStorageDirectoryHandle = class _CachedStorageDirectoryHandle {
  constructor(inner, cache, path) {
    this.inner = inner;
    this.cache = cache;
    this.path = path;
    this.name = inner.name;
  }
  getDirectoryHandle(name, options) {
    return __async(this, null, function* () {
      const childPath = joinPath(this.path, name);
      if (options == null ? void 0 : options.create) {
        const handle2 = yield this.inner.getDirectoryHandle(name, options);
        this.cache.entries.delete(normalizePath(this.path));
        const cached2 = new _CachedStorageDirectoryHandle(handle2, this.cache, childPath);
        this.cache.directories.set(normalizePath(childPath), cached2);
        return cached2;
      }
      const startTime = performance.now();
      const normalizedChildPath = normalizePath(childPath);
      const cachedHandle = this.cache.directories.get(normalizedChildPath);
      if (cachedHandle) {
        this.cache.recordDirectoriesHit(performance.now() - startTime);
        return cachedHandle;
      }
      const handle = yield this.inner.getDirectoryHandle(name);
      this.cache.recordDirectoriesMiss(performance.now() - startTime);
      const cached = new _CachedStorageDirectoryHandle(handle, this.cache, childPath);
      this.cache.directories.set(normalizedChildPath, cached);
      return cached;
    });
  }
  getFileHandle(name, options) {
    return __async(this, null, function* () {
      const childPath = joinPath(this.path, name);
      if (options == null ? void 0 : options.create) {
        const handle2 = yield this.inner.getFileHandle(name, options);
        this.cache.entries.delete(normalizePath(this.path));
        const cached2 = new CachedStorageFileHandle(handle2, this.cache, childPath, this.path);
        this.cache.files.set(normalizePath(childPath), cached2);
        return cached2;
      }
      const startTime = performance.now();
      const normalizedChildPath = normalizePath(childPath);
      const cachedHandle = this.cache.files.get(normalizedChildPath);
      if (cachedHandle) {
        this.cache.recordFilesHit(performance.now() - startTime);
        return cachedHandle;
      }
      const handle = yield this.inner.getFileHandle(name);
      this.cache.recordFilesMiss(performance.now() - startTime);
      const cached = new CachedStorageFileHandle(handle, this.cache, childPath, this.path);
      this.cache.files.set(normalizedChildPath, cached);
      return cached;
    });
  }
  removeEntry(name, options) {
    return __async(this, null, function* () {
      const childPath = joinPath(this.path, name);
      yield this.inner.removeEntry(name, options);
      this.cache.entries.delete(normalizePath(this.path));
      this.cache.invalidate(childPath);
    });
  }
  values() {
    return __asyncGenerator(this, null, function* () {
      const normalizedPath = normalizePath(this.path);
      const startTime = performance.now();
      const cachedEntries = this.cache.entries.get(normalizedPath);
      if (cachedEntries) {
        this.cache.recordEntriesHit(performance.now() - startTime);
        for (const entry of cachedEntries) {
          yield entry;
        }
        return;
      }
      const entries = [];
      try {
        for (var iter = __forAwait(this.inner.values()), more, temp, error; more = !(temp = yield new __await(iter.next())).done; more = false) {
          const entry = temp.value;
          entries.push(entry);
        }
      } catch (temp) {
        error = [temp];
      } finally {
        try {
          more && (temp = iter.return) && (yield new __await(temp.call(iter)));
        } finally {
          if (error)
            throw error[0];
        }
      }
      this.cache.recordEntriesMiss(performance.now() - startTime);
      this.cache.entries.set(normalizedPath, entries);
      for (const entry of entries) {
        yield entry;
      }
    });
  }
};
var CachedStorageFileHandle = class {
  constructor(inner, cache, path, parentPath) {
    this.inner = inner;
    this.cache = cache;
    this.path = path;
    this.parentPath = parentPath;
    this.name = inner.name;
  }
  getFile() {
    return __async(this, null, function* () {
      const normalizedPath = normalizePath(this.path);
      const startTime = performance.now();
      const cachedContent = this.cache.content.get(normalizedPath);
      if (cachedContent) {
        this.cache.recordContentHit(performance.now() - startTime);
        return cachedContent;
      }
      const file = yield this.inner.getFile();
      this.cache.recordContentMiss(performance.now() - startTime);
      const cachedFile = new CachedStorageFile(file);
      this.cache.content.set(normalizedPath, cachedFile);
      return cachedFile;
    });
  }
  createWritable() {
    return __async(this, null, function* () {
      const writable = yield this.inner.createWritable();
      return new CachedStorageWritable(writable, this.cache, this.path, this.parentPath);
    });
  }
};
var CachedStorageFile = class {
  constructor(inner) {
    this.inner = inner;
    this.cachedText = null;
    this.cachedArrayBuffer = null;
    this.size = inner.size;
  }
  text() {
    return __async(this, null, function* () {
      if (this.cachedText !== null) {
        return this.cachedText;
      }
      if (this.cachedArrayBuffer !== null) {
        this.cachedText = new TextDecoder().decode(this.cachedArrayBuffer);
        return this.cachedText;
      }
      this.cachedText = yield this.inner.text();
      return this.cachedText;
    });
  }
  arrayBuffer() {
    return __async(this, null, function* () {
      if (this.cachedArrayBuffer !== null) {
        return this.cachedArrayBuffer;
      }
      if (this.cachedText !== null) {
        this.cachedArrayBuffer = new TextEncoder().encode(this.cachedText).buffer;
        return this.cachedArrayBuffer;
      }
      this.cachedArrayBuffer = yield this.inner.arrayBuffer();
      return this.cachedArrayBuffer;
    });
  }
  /**
   * Return a readable stream of the file content.
   * If content is already cached, stream from the cached buffer.
   * Otherwise, delegate to the inner file's stream.
   */
  stream() {
    if (this.cachedArrayBuffer !== null) {
      return this.createStreamFromBuffer(this.cachedArrayBuffer);
    }
    if (this.cachedText !== null) {
      const buffer = new TextEncoder().encode(this.cachedText).buffer;
      return this.createStreamFromBuffer(buffer);
    }
    return this.createCachingStream();
  }
  /**
   * Create a ReadableStream from an existing ArrayBuffer.
   */
  createStreamFromBuffer(buffer) {
    const bytes = new Uint8Array(buffer);
    return new ReadableStream({
      start(controller) {
        controller.enqueue(bytes);
        controller.close();
      }
    });
  }
  /**
   * Create a stream that reads from inner and caches the result.
   */
  createCachingStream() {
    const inner = this.inner;
    const chunks = [];
    const self = this;
    return new ReadableStream({
      start(controller) {
        return __async(this, null, function* () {
          try {
            const reader = inner.stream().getReader();
            while (true) {
              const { done, value } = yield reader.read();
              if (done) break;
              chunks.push(value);
              controller.enqueue(value);
            }
            const totalLength = chunks.reduce((sum, chunk) => sum + chunk.length, 0);
            const combined = new Uint8Array(totalLength);
            let offset = 0;
            for (const chunk of chunks) {
              combined.set(chunk, offset);
              offset += chunk.length;
            }
            self.cachedArrayBuffer = combined.buffer;
            controller.close();
          } catch (err) {
            controller.error(err);
          }
        });
      }
    });
  }
};
var CachedStorageWritable = class {
  constructor(inner, cache, filePath, parentPath) {
    this.inner = inner;
    this.cache = cache;
    this.filePath = filePath;
    this.parentPath = parentPath;
  }
  write(data) {
    return __async(this, null, function* () {
      return this.inner.write(data);
    });
  }
  close() {
    return __async(this, null, function* () {
      yield this.inner.close();
      this.cache.invalidateFile(this.filePath);
      this.cache.entries.delete(normalizePath(this.parentPath));
    });
  }
};
function withCache(root) {
  const cache = new StorageCache();
  const cached = new CachedStorageDirectoryHandle(root, cache, "");
  return {
    get name() {
      return cached.name;
    },
    getDirectoryHandle: cached.getDirectoryHandle.bind(cached),
    getFileHandle: cached.getFileHandle.bind(cached),
    removeEntry: cached.removeEntry.bind(cached),
    values: cached.values.bind(cached),
    clearCache: () => cache.clear(),
    getMetrics: () => cache.getMetrics(),
    resetMetrics: () => cache.resetMetrics()
  };
}

// src/library-fs.ts
import { parse as parseYaml } from "yaml";
var LIBRARY_CATEGORIES = ["tones", "patches"];
function getNestedDirectory(rootHandle, path) {
  return __async(this, null, function* () {
    let current = rootHandle;
    for (const segment of path) {
      current = yield current.getDirectoryHandle(segment, { create: true });
    }
    return current;
  });
}
function getNestedDirectoryReadOnly(rootHandle, path) {
  return __async(this, null, function* () {
    let current = rootHandle;
    for (const segment of path) {
      current = yield current.getDirectoryHandle(segment);
    }
    return current;
  });
}
function getNestedDirectoryIfExists(rootHandle, path) {
  return __async(this, null, function* () {
    let current = rootHandle;
    try {
      for (const segment of path) {
        current = yield current.getDirectoryHandle(segment);
      }
      return current;
    } catch (e) {
      return null;
    }
  });
}
function copyDirectoryContents(src, dest) {
  return __async(this, null, function* () {
    try {
      for (var iter = __forAwait(src.values()), more, temp, error; more = !(temp = yield iter.next()).done; more = false) {
        const entry = temp.value;
        if (entry.kind === "file") {
          const srcFile = yield src.getFileHandle(entry.name);
          const file = yield srcFile.getFile();
          const destFile = yield dest.getFileHandle(entry.name, { create: true });
          const writable = yield destFile.createWritable();
          yield writable.write(yield file.arrayBuffer());
          yield writable.close();
        } else {
          const srcSub = yield src.getDirectoryHandle(entry.name);
          const destSub = yield dest.getDirectoryHandle(entry.name, { create: true });
          yield copyDirectoryContents(srcSub, destSub);
        }
      }
    } catch (temp) {
      error = [temp];
    } finally {
      try {
        more && (temp = iter.return) && (yield temp.call(iter));
      } finally {
        if (error)
          throw error[0];
      }
    }
  });
}
function moveDirectory(parentDir, name, targetParentDir, newName) {
  return __async(this, null, function* () {
    const destName = newName != null ? newName : name;
    const srcDir = yield parentDir.getDirectoryHandle(name, { create: false });
    const destDir = yield targetParentDir.getDirectoryHandle(destName, { create: true });
    yield copyDirectoryContents(srcDir, destDir);
    yield parentDir.removeEntry(name, { recursive: true });
  });
}
function isValidMoveTarget(sourcePath, sourceName, targetPath) {
  const sourceFullPath = [...sourcePath, sourceName].join("/");
  const targetFullPath = targetPath.join("/");
  if (targetFullPath === sourceFullPath || targetFullPath.startsWith(sourceFullPath + "/")) {
    return false;
  }
  if (sourcePath.join("/") === targetFullPath) {
    return false;
  }
  return true;
}
function sortNodes(nodes) {
  return nodes.sort((a, b) => {
    if (a.type === "directory" && b.type !== "directory") return -1;
    if (a.type !== "directory" && b.type === "directory") return 1;
    return a.name.localeCompare(b.name);
  });
}
function scanLibraryDirectory(dir, path, detectItem) {
  return __async(this, null, function* () {
    const nodes = [];
    try {
      for (var iter = __forAwait(dir.values()), more, temp, error; more = !(temp = yield iter.next()).done; more = false) {
        const entry = temp.value;
        const detected = yield detectItem(entry, dir, path);
        if (detected) {
          nodes.push(detected);
        } else if (entry.kind === "directory") {
          const subDir = yield dir.getDirectoryHandle(entry.name);
          const children = yield scanLibraryDirectory(subDir, [...path, entry.name], detectItem);
          nodes.push({
            id: [...path, entry.name].join("/"),
            name: entry.name,
            type: "directory",
            path,
            children
          });
        }
      }
    } catch (temp) {
      error = [temp];
    } finally {
      try {
        more && (temp = iter.return) && (yield temp.call(iter));
      } finally {
        if (error)
          throw error[0];
      }
    }
    return sortNodes(nodes);
  });
}
var detectTone = (entry, _parentDir, path) => __async(null, null, function* () {
  if (entry.kind !== "file" || !entry.name.toLowerCase().endsWith(".yaml")) return null;
  const fileName = entry.name.replace(/\.yaml$/i, "");
  return {
    id: [...path, fileName].join("/"),
    name: fileName,
    type: "tone",
    path,
    fileName
  };
});
var detectPatch = (entry, parentDir, path) => __async(null, null, function* () {
  if (entry.kind !== "directory") return null;
  const subDir = yield parentDir.getDirectoryHandle(entry.name);
  let isPatchBundle = false;
  let patchName = entry.name;
  let toneCount = 0;
  try {
    const yamlHandle = yield subDir.getFileHandle("patch.yaml");
    const yamlFile = yield yamlHandle.getFile();
    const content = yield yamlFile.text();
    const yaml = parseYaml(content);
    patchName = yaml.name || entry.name;
    isPatchBundle = true;
    try {
      const tonesDir = yield subDir.getDirectoryHandle("tones");
      try {
        for (var iter = __forAwait(tonesDir.values()), more, temp, error; more = !(temp = yield iter.next()).done; more = false) {
          const toneEntry = temp.value;
          if (toneEntry.kind === "file" && toneEntry.name.endsWith(".yaml")) {
            toneCount++;
          }
        }
      } catch (temp) {
        error = [temp];
      } finally {
        try {
          more && (temp = iter.return) && (yield temp.call(iter));
        } finally {
          if (error)
            throw error[0];
        }
      }
    } catch (e) {
    }
  } catch (e) {
  }
  if (!isPatchBundle) return null;
  return {
    id: [...path, entry.name].join("/"),
    name: patchName,
    type: "patch",
    path,
    directoryName: entry.name,
    toneCount
  };
});
function scanTonesDirectory(dir, path) {
  return __async(this, null, function* () {
    return scanLibraryDirectory(dir, path, detectTone);
  });
}
function listTonesTree(root, device) {
  return __async(this, null, function* () {
    const tonesDir = yield getNestedDirectoryIfExists(root, ["library", device, "tones"]);
    if (!tonesDir) return [];
    return scanTonesDirectory(tonesDir, []);
  });
}
function scanPatchesDirectory(dir, path) {
  return __async(this, null, function* () {
    return scanLibraryDirectory(dir, path, detectPatch);
  });
}
function listPatchesTree(root, device) {
  return __async(this, null, function* () {
    const patchesDir = yield getNestedDirectoryIfExists(root, ["library", device, "patches"]);
    if (!patchesDir) return [];
    return scanPatchesDirectory(patchesDir, []);
  });
}
var detectSample = (entry, parentDir, path) => __async(null, null, function* () {
  var _a;
  if (entry.kind !== "directory") return null;
  try {
    const sampleDir = yield parentDir.getDirectoryHandle(entry.name);
    const yamlHandle = yield sampleDir.getFileHandle("sample.yaml");
    const file = yield yamlHandle.getFile();
    const text = yield file.text();
    const parsed = parseYaml(text);
    const result = SampleYamlSchema.safeParse(parsed);
    if (!result.success) return null;
    const data = result.data;
    let sampleCount;
    const sampleRate = data.sampleRate;
    try {
      const wavHandle = yield sampleDir.getFileHandle(data.file);
      const wavFile = yield wavHandle.getFile();
      const dataBytes = wavFile.size - 44;
      if (dataBytes > 0) {
        sampleCount = Math.floor(dataBytes / 2);
      }
    } catch (e) {
    }
    return {
      id: [...path, entry.name].join("/"),
      name: data.name,
      type: "sample",
      path,
      directoryName: entry.name,
      description: data.description,
      sliceCount: (_a = data.slices) == null ? void 0 : _a.length,
      hasDrumKit: data.drumKit !== void 0,
      sampleCount,
      sampleRate
    };
  } catch (e) {
    return null;
  }
});
var detectProgram = (entry, parentDir, path) => __async(null, null, function* () {
  if (entry.kind !== "directory") return null;
  const subDir = yield parentDir.getDirectoryHandle(entry.name);
  try {
    const manifestHandle = yield subDir.getFileHandle("program.yaml");
    const file = yield manifestHandle.getFile();
    const text = yield file.text();
    const parsed = parseYaml(text);
    const result = ProgramYamlSchema.safeParse(parsed);
    if (!result.success) return null;
    const programPath = [...path, entry.name];
    const children = [];
    try {
      const samplesDir = yield subDir.getDirectoryHandle("samples");
      try {
        for (var iter = __forAwait(samplesDir.values()), more, temp, error; more = !(temp = yield iter.next()).done; more = false) {
          const sampleEntry = temp.value;
          if (sampleEntry.kind !== "file") continue;
          if (!sampleEntry.name.endsWith(".wav")) continue;
          const sampleName = sampleEntry.name.replace(/\.wav$/, "");
          children.push({
            id: [...programPath, "samples", sampleName].join("/"),
            name: sampleName,
            type: "sample",
            path: programPath,
            fileName: sampleName
          });
        }
      } catch (temp) {
        error = [temp];
      } finally {
        try {
          more && (temp = iter.return) && (yield temp.call(iter));
        } finally {
          if (error)
            throw error[0];
        }
      }
      children.sort((a, b) => a.name.localeCompare(b.name));
    } catch (e) {
    }
    return {
      id: programPath.join("/"),
      name: result.data.name,
      type: "program",
      path,
      directoryName: entry.name,
      description: result.data.description,
      kitCount: result.data.zones.length,
      children: children.length > 0 ? children : void 0
    };
  } catch (e) {
    return null;
  }
});
var detectCommonItem = (entry, parentDir, path) => __async(null, null, function* () {
  const sample = yield detectSample(entry, parentDir, path);
  if (sample) return sample;
  const program = yield detectProgram(entry, parentDir, path);
  if (program) return program;
  return null;
});
function scanCommonSamplesDirectory(dir, path) {
  return __async(this, null, function* () {
    return scanLibraryDirectory(dir, path, detectCommonItem);
  });
}
function listCommonSamplesTree(root) {
  return __async(this, null, function* () {
    const samplesDir = yield getNestedDirectoryIfExists(root, ["library", "common", "samples"]);
    if (!samplesDir) return [];
    return scanCommonSamplesDirectory(samplesDir, []);
  });
}
function listCommonProgramsTree(root) {
  return __async(this, null, function* () {
    const programsDir = yield getNestedDirectoryIfExists(root, ["library", "common", "programs"]);
    if (!programsDir) return [];
    return scanLibraryDirectory(programsDir, [], detectProgram);
  });
}
function listSets(root, device) {
  return __async(this, null, function* () {
    var _a, _b, _c, _d, _e;
    const setsDir = yield getNestedDirectoryIfExists(root, ["library", device, "sets"]);
    if (!setsDir) return [];
    const sets = [];
    try {
      for (var iter = __forAwait(setsDir.values()), more, temp, error; more = !(temp = yield iter.next()).done; more = false) {
        const entry = temp.value;
        if (entry.kind !== "directory") continue;
        try {
          const setDir = yield setsDir.getDirectoryHandle(entry.name);
          const manifestHandle = yield setDir.getFileHandle("set.yaml");
          const manifestFile = yield manifestHandle.getFile();
          const manifestContent = yield manifestFile.text();
          const manifest = parseYaml(manifestContent);
          sets.push({
            name: (_a = manifest.name) != null ? _a : entry.name,
            description: manifest.description,
            createdAt: manifest.createdAt,
            modifiedAt: manifest.modifiedAt,
            toneCount: (_c = (_b = manifest.tones) == null ? void 0 : _b.length) != null ? _c : 0,
            patchCount: (_e = (_d = manifest.patches) == null ? void 0 : _d.length) != null ? _e : 0,
            directoryName: entry.name
          });
        } catch (e) {
        }
      }
    } catch (temp) {
      error = [temp];
    } finally {
      try {
        more && (temp = iter.return) && (yield temp.call(iter));
      } finally {
        if (error)
          throw error[0];
      }
    }
    return sets.sort((a, b) => a.name.localeCompare(b.name));
  });
}
function listSetTonesTree(root, device, setName) {
  return __async(this, null, function* () {
    const tonesDir = yield getNestedDirectoryIfExists(
      root,
      ["library", device, "sets", setName, "tones"]
    );
    if (!tonesDir) return [];
    return scanTonesDirectory(tonesDir, []);
  });
}

// src/common-area/samples.ts
import { parse as parseYaml2, stringify as stringifyYaml2 } from "yaml";

// src/common-area/import.ts
import { stringify as stringifyYaml } from "yaml";
var MAX_NAME_LENGTH = 128;
var UNSAFE_FILENAME_CHARS = /[<>:"/\\|?*]/g;
var MIN_WAV_SIZE = 20;
var CHUNK_HEADER_SIZE = 8;
var MIN_FMT_SIZE = 8;
function readUint32LE(data, offset) {
  return (data[offset] | data[offset + 1] << 8 | data[offset + 2] << 16 | data[offset + 3] << 24) >>> 0;
}
function matchTag(data, offset, tag) {
  return data[offset] === tag.charCodeAt(0) && data[offset + 1] === tag.charCodeAt(1) && data[offset + 2] === tag.charCodeAt(2) && data[offset + 3] === tag.charCodeAt(3);
}
function extractWavSampleRate(data) {
  if (data.length < MIN_WAV_SIZE) {
    throw new Error(
      `WAV data too short: expected at least ${MIN_WAV_SIZE} bytes, got ${data.length}`
    );
  }
  if (!matchTag(data, 0, "RIFF")) {
    throw new Error("Invalid WAV file: missing RIFF header");
  }
  if (!matchTag(data, 8, "WAVE")) {
    throw new Error("Invalid WAV file: missing WAVE format marker");
  }
  let offset = 12;
  while (offset + CHUNK_HEADER_SIZE <= data.length) {
    const chunkSize = readUint32LE(data, offset + 4);
    if (matchTag(data, offset, "fmt ")) {
      const payloadStart = offset + CHUNK_HEADER_SIZE;
      if (payloadStart + MIN_FMT_SIZE > data.length) {
        throw new Error("Invalid WAV file: fmt chunk truncated");
      }
      const sampleRate = readUint32LE(data, payloadStart + 4);
      if (sampleRate === 0) {
        throw new Error("Invalid WAV file: sample rate is zero");
      }
      return sampleRate;
    }
    const paddedSize = chunkSize + chunkSize % 2;
    offset += CHUNK_HEADER_SIZE + paddedSize;
  }
  throw new Error("Invalid WAV file: fmt chunk not found");
}
function sanitizeForFilename(input) {
  return input.trim().replace(UNSAFE_FILENAME_CHARS, "_").replace(/\s+/g, "_").replace(/_+/g, "_");
}
function deriveSampleName(wavFilename) {
  const withoutExtension = wavFilename.replace(/\.wav$/i, "");
  const sanitized = sanitizeForFilename(withoutExtension);
  return sanitized.slice(0, MAX_NAME_LENGTH);
}
function buildSampleYaml(wavFilename, sampleRate, options) {
  var _a;
  const name = (_a = options == null ? void 0 : options.name) != null ? _a : deriveSampleName(wavFilename);
  const yaml = {
    format: "sample",
    version: 1,
    name,
    file: "sample.wav",
    sampleRate
  };
  if ((options == null ? void 0 : options.tags) && options.tags.length > 0) {
    yaml.tags = options.tags;
  }
  if (options == null ? void 0 : options.description) {
    yaml.description = options.description;
  }
  return yaml;
}
function importWavToCommonArea(rootHandle, wavFilename, wavData, options) {
  return __async(this, null, function* () {
    const sampleRate = extractWavSampleRate(wavData);
    const sampleYaml = buildSampleYaml(wavFilename, sampleRate, options);
    const basePath = ["library", "common", "samples"];
    const fullPath = (options == null ? void 0 : options.targetPath) ? [...basePath, ...options.targetPath] : basePath;
    const parentDir = yield getNestedDirectory(rootHandle, fullPath);
    const safeName = sanitizeForFilename(sampleYaml.name);
    const sampleDir = yield parentDir.getDirectoryHandle(safeName, { create: true });
    const yamlContent = stringifyYaml(sampleYaml);
    const yamlHandle = yield sampleDir.getFileHandle("sample.yaml", { create: true });
    const yamlWritable = yield yamlHandle.createWritable();
    yield yamlWritable.write(yamlContent);
    yield yamlWritable.close();
    const wavBuffer = wavData.buffer.slice(
      wavData.byteOffset,
      wavData.byteOffset + wavData.byteLength
    );
    const wavHandle = yield sampleDir.getFileHandle("sample.wav", { create: true });
    const wavWritable = yield wavHandle.createWritable();
    yield wavWritable.write(wavBuffer);
    yield wavWritable.close();
    return sampleYaml;
  });
}

// src/common-area/streaming.ts
function readFileWithProgress(file, onProgress) {
  return __async(this, null, function* () {
    if (!onProgress) {
      return file.arrayBuffer();
    }
    const totalBytes = file.size;
    let bytesRead = 0;
    onProgress(0, totalBytes);
    const stream = file.stream();
    const reader = stream.getReader();
    const chunks = [];
    try {
      while (true) {
        const { done, value } = yield reader.read();
        if (done) break;
        chunks.push(value);
        bytesRead += value.length;
        onProgress(bytesRead, totalBytes);
      }
    } finally {
      reader.releaseLock();
    }
    const result = new Uint8Array(bytesRead);
    let offset = 0;
    for (const chunk of chunks) {
      result.set(chunk, offset);
      offset += chunk.length;
    }
    return result.buffer;
  });
}
function readTextWithProgress(file, onProgress) {
  return __async(this, null, function* () {
    const buffer = yield readFileWithProgress(file, onProgress);
    return new TextDecoder().decode(buffer);
  });
}

// src/common-area/samples.ts
var SAMPLES_ROOT = ["library", "common", "samples"];
function getSamplesDir(_0) {
  return __async(this, arguments, function* (root, path = []) {
    return getNestedDirectory(root, [...SAMPLES_ROOT, ...path]);
  });
}
function getSamplesDirReadOnly(_0) {
  return __async(this, arguments, function* (root, path = []) {
    return getNestedDirectoryReadOnly(root, [...SAMPLES_ROOT, ...path]);
  });
}
function saveSample(_0, _1) {
  return __async(this, arguments, function* (root, payload, path = [], options) {
    const parentDir = yield getSamplesDir(root, path);
    const safeName = sanitizeForFilename(payload.name);
    const { onProgress } = options != null ? options : {};
    const sampleDir = yield parentDir.getDirectoryHandle(safeName, { create: true });
    const yamlContent = stringifyYaml2(payload.yaml, { indent: 2, lineWidth: 120 });
    const yamlBytes = new TextEncoder().encode(yamlContent).length;
    const wavBytes = payload.wavData.byteLength;
    const totalBytes = yamlBytes + wavBytes;
    onProgress == null ? void 0 : onProgress({
      currentStep: 1,
      totalSteps: 2,
      stepLabel: `Saving metadata: ${safeName}/sample.yaml`,
      bytesSent: 0,
      bytesTotal: yamlBytes,
      bytesSentAllSteps: 0,
      bytesTotalAllSteps: totalBytes
    });
    const yamlHandle = yield sampleDir.getFileHandle("sample.yaml", { create: true });
    const yamlWritable = yield yamlHandle.createWritable();
    yield yamlWritable.write(yamlContent);
    yield yamlWritable.close();
    onProgress == null ? void 0 : onProgress({
      currentStep: 1,
      totalSteps: 2,
      stepLabel: `Saving metadata: ${safeName}/sample.yaml`,
      bytesSent: yamlBytes,
      bytesTotal: yamlBytes,
      bytesSentAllSteps: 0,
      bytesTotalAllSteps: totalBytes
    });
    onProgress == null ? void 0 : onProgress({
      currentStep: 2,
      totalSteps: 2,
      stepLabel: `Saving audio: ${safeName}/sample.wav`,
      bytesSent: 0,
      bytesTotal: wavBytes,
      bytesSentAllSteps: yamlBytes,
      bytesTotalAllSteps: totalBytes
    });
    const wavHandle = yield sampleDir.getFileHandle("sample.wav", { create: true });
    const wavWritable = yield wavHandle.createWritable();
    yield wavWritable.write(payload.wavData);
    yield wavWritable.close();
    onProgress == null ? void 0 : onProgress({
      currentStep: 2,
      totalSteps: 2,
      stepLabel: `Saving audio: ${safeName}/sample.wav`,
      bytesSent: wavBytes,
      bytesTotal: wavBytes,
      bytesSentAllSteps: yamlBytes,
      bytesTotalAllSteps: totalBytes
    });
  });
}
function loadSample(_0, _1) {
  return __async(this, arguments, function* (root, name, path = [], options) {
    const parentDir = yield getSamplesDirReadOnly(root, path);
    const safeName = sanitizeForFilename(name);
    const { onProgress } = options != null ? options : {};
    const sampleDir = yield parentDir.getDirectoryHandle(safeName);
    const yamlHandle = yield sampleDir.getFileHandle("sample.yaml");
    const yamlFile = yield yamlHandle.getFile();
    const wavHandle = yield sampleDir.getFileHandle("sample.wav");
    const wavFile = yield wavHandle.getFile();
    const yamlSize = yamlFile.size;
    const wavSize = wavFile.size;
    const totalBytes = yamlSize + wavSize;
    const yamlProgressCallback = onProgress ? (bytesRead, bytesTotal) => {
      onProgress({
        currentStep: 1,
        totalSteps: 2,
        stepLabel: `Loading metadata: ${safeName}/sample.yaml`,
        bytesSent: bytesRead,
        bytesTotal,
        bytesSentAllSteps: 0,
        bytesTotalAllSteps: totalBytes
      });
    } : void 0;
    const yamlText = yield readTextWithProgress(yamlFile, yamlProgressCallback);
    const parsed = parseYaml2(yamlText);
    const result = SampleYamlSchema.safeParse(parsed);
    if (!result.success) {
      throw new Error(`Invalid sample YAML for "${name}": ${result.error.message}`);
    }
    const wavProgressCallback = onProgress ? (bytesRead, bytesTotal) => {
      onProgress({
        currentStep: 2,
        totalSteps: 2,
        stepLabel: `Loading audio: ${safeName}/sample.wav`,
        bytesSent: bytesRead,
        bytesTotal,
        bytesSentAllSteps: yamlSize,
        bytesTotalAllSteps: totalBytes
      });
    } : void 0;
    const wavData = yield readFileWithProgress(wavFile, wavProgressCallback);
    return { yaml: result.data, wavData };
  });
}
function loadSampleMeta(_0, _1) {
  return __async(this, arguments, function* (root, name, path = [], options) {
    const parentDir = yield getSamplesDirReadOnly(root, path);
    const safeName = sanitizeForFilename(name);
    const { onProgress } = options != null ? options : {};
    const sampleDir = yield parentDir.getDirectoryHandle(safeName);
    const yamlHandle = yield sampleDir.getFileHandle("sample.yaml");
    const yamlFile = yield yamlHandle.getFile();
    const totalBytes = yamlFile.size;
    const progressCallback = onProgress ? (bytesRead, bytesTotal) => {
      onProgress({
        currentStep: 1,
        totalSteps: 1,
        stepLabel: `Loading metadata: ${safeName}/sample.yaml`,
        bytesSent: bytesRead,
        bytesTotal,
        bytesSentAllSteps: 0,
        bytesTotalAllSteps: totalBytes
      });
    } : void 0;
    const yamlText = yield readTextWithProgress(yamlFile, progressCallback);
    const parsed = parseYaml2(yamlText);
    const result = SampleYamlSchema.safeParse(parsed);
    if (!result.success) {
      throw new Error(`Invalid sample YAML for "${name}": ${result.error.message}`);
    }
    return result.data;
  });
}
function saveChoppedSample(_0, _1) {
  return __async(this, arguments, function* (root, payload, path = []) {
    const result = ChoppedSampleSchema.safeParse(payload.manifest);
    if (!result.success) {
      throw new Error(`Invalid manifest: ${result.error.message}`);
    }
    const manifest = result.data;
    const sampleYaml = {
      format: "sample",
      version: 1,
      name: manifest.name,
      file: "sample.wav",
      sampleRate: manifest.sampleRate,
      description: manifest.description,
      slices: manifest.slices,
      triggers: manifest.triggers,
      playback: manifest.playback,
      drumKit: manifest.variant === "drum-kit" ? manifest.drumKit : void 0,
      createdAt: manifest.createdAt,
      modifiedAt: manifest.modifiedAt
    };
    yield saveSample(root, { name: payload.name, yaml: sampleYaml, wavData: payload.wavData }, path);
  });
}
function loadChoppedSample(_0, _1) {
  return __async(this, arguments, function* (root, name, path = []) {
    const parentDir = yield getSamplesDirReadOnly(root, path);
    const safeName = sanitizeForFilename(name);
    const sampleDir = yield parentDir.getDirectoryHandle(safeName);
    const yamlHandle = yield sampleDir.getFileHandle("sample.yaml");
    const yamlFile = yield yamlHandle.getFile();
    const yamlText = yield yamlFile.text();
    const parsed = parseYaml2(yamlText);
    const result = SampleYamlSchema.safeParse(parsed);
    if (!result.success) {
      throw new Error(`Invalid sample YAML for "${name}": ${result.error.message}`);
    }
    if (!result.data.slices) {
      throw new Error(`Sample "${name}" has no slices`);
    }
    const wavHandle = yield sampleDir.getFileHandle("sample.wav");
    const wavFile = yield wavHandle.getFile();
    const wavData = yield wavFile.arrayBuffer();
    const manifest = __spreadProps(__spreadValues({
      format: "chopped-sample",
      version: 1,
      variant: result.data.drumKit ? "drum-kit" : "generic",
      name: result.data.name,
      source: result.data.file,
      sampleRate: result.data.sampleRate,
      slices: result.data.slices,
      triggers: result.data.triggers,
      playback: result.data.playback
    }, result.data.drumKit ? { drumKit: result.data.drumKit } : {}), {
      description: result.data.description,
      createdAt: result.data.createdAt,
      modifiedAt: result.data.modifiedAt
    });
    return { manifest, wavData };
  });
}
function deleteItem(_0, _1) {
  return __async(this, arguments, function* (root, name, path = []) {
    const dir = yield getSamplesDir(root, path);
    yield dir.removeEntry(name, { recursive: true });
  });
}
function createFolder(root, path, name) {
  return __async(this, null, function* () {
    const parentDir = yield getSamplesDir(root, path);
    yield parentDir.getDirectoryHandle(name, { create: true });
  });
}
function moveItem(root, name, fromPath, toPath) {
  return __async(this, null, function* () {
    const srcParent = yield getSamplesDir(root, fromPath);
    const destParent = yield getSamplesDir(root, toPath);
    yield moveDirectory(srcParent, name, destParent);
  });
}

// src/common-area/programs.ts
import { parse as parseYaml3, stringify as stringifyYaml3 } from "yaml";
var SAMPLES_ROOT2 = ["library", "common", "samples"];
var PROGRAMS_ROOT = ["library", "common", "programs"];
function getProgramsDir(root) {
  return __async(this, null, function* () {
    return getNestedDirectory(root, PROGRAMS_ROOT);
  });
}
function getProgramsDirReadOnly(root) {
  return __async(this, null, function* () {
    return getNestedDirectoryReadOnly(root, PROGRAMS_ROOT);
  });
}
function getSamplesDirReadOnly2(_0) {
  return __async(this, arguments, function* (root, path = []) {
    return getNestedDirectoryReadOnly(root, [...SAMPLES_ROOT2, ...path]);
  });
}
function saveProgram(root, payload, options) {
  return __async(this, null, function* () {
    const validated = ProgramYamlSchema.safeParse(payload.yaml);
    if (!validated.success) {
      throw new Error(`Invalid program YAML: ${validated.error.message}`);
    }
    const programsDir = yield getProgramsDir(root);
    const safeName = sanitizeForFilename(payload.name);
    const { onProgress } = options != null ? options : {};
    const programDir = yield programsDir.getDirectoryHandle(safeName, { create: true });
    const yamlContent = stringifyYaml3(validated.data, { indent: 2, lineWidth: 120 });
    const yamlBytes = new TextEncoder().encode(yamlContent).length;
    const wavTotalBytes = payload.wavFiles.reduce((sum, f) => sum + f.data.byteLength, 0);
    const totalBytes = yamlBytes + wavTotalBytes;
    const totalSteps = 1 + payload.wavFiles.length;
    onProgress == null ? void 0 : onProgress({
      currentStep: 1,
      totalSteps,
      stepLabel: `Saving metadata: ${safeName}/program.yaml`,
      bytesSent: 0,
      bytesTotal: yamlBytes,
      bytesSentAllSteps: 0,
      bytesTotalAllSteps: totalBytes
    });
    const yamlHandle = yield programDir.getFileHandle("program.yaml", { create: true });
    const yamlWritable = yield yamlHandle.createWritable();
    yield yamlWritable.write(yamlContent);
    yield yamlWritable.close();
    onProgress == null ? void 0 : onProgress({
      currentStep: 1,
      totalSteps,
      stepLabel: `Saving metadata: ${safeName}/program.yaml`,
      bytesSent: yamlBytes,
      bytesTotal: yamlBytes,
      bytesSentAllSteps: 0,
      bytesTotalAllSteps: totalBytes
    });
    if (payload.wavFiles.length > 0) {
      const samplesDir = yield programDir.getDirectoryHandle("samples", { create: true });
      let bytesSentPrior = yamlBytes;
      for (let i = 0; i < payload.wavFiles.length; i++) {
        const wavFile = payload.wavFiles[i];
        const step = i + 2;
        const wavBytes = wavFile.data.byteLength;
        onProgress == null ? void 0 : onProgress({
          currentStep: step,
          totalSteps,
          stepLabel: `Saving audio: ${safeName}/samples/${wavFile.filename}`,
          bytesSent: 0,
          bytesTotal: wavBytes,
          bytesSentAllSteps: bytesSentPrior,
          bytesTotalAllSteps: totalBytes
        });
        const wavHandle = yield samplesDir.getFileHandle(wavFile.filename, { create: true });
        const wavWritable = yield wavHandle.createWritable();
        yield wavWritable.write(wavFile.data);
        yield wavWritable.close();
        bytesSentPrior += wavBytes;
        onProgress == null ? void 0 : onProgress({
          currentStep: step,
          totalSteps,
          stepLabel: `Saving audio: ${safeName}/samples/${wavFile.filename}`,
          bytesSent: wavBytes,
          bytesTotal: wavBytes,
          bytesSentAllSteps: bytesSentPrior,
          bytesTotalAllSteps: totalBytes
        });
      }
    }
  });
}
function resolveProgramDir(parentDir, name) {
  return __async(this, null, function* () {
    const safeName = sanitizeForFilename(name);
    try {
      return yield parentDir.getDirectoryHandle(safeName);
    } catch (e) {
      return parentDir.getDirectoryHandle(name.trim());
    }
  });
}
function readProgramYaml(programDir, name) {
  return __async(this, null, function* () {
    const yamlHandle = yield programDir.getFileHandle("program.yaml");
    const yamlFile = yield yamlHandle.getFile();
    const yamlText = yield yamlFile.text();
    const parsed = parseYaml3(yamlText);
    const result = ProgramYamlSchema.safeParse(parsed);
    if (!result.success) {
      throw new Error(`Invalid program YAML for "${name}": ${result.error.message}`);
    }
    return result.data;
  });
}
function loadProgramMeta(root, name, path) {
  return __async(this, null, function* () {
    const parentDir = path !== void 0 ? yield getSamplesDirReadOnly2(root, path) : yield getProgramsDirReadOnly(root);
    const programDir = yield resolveProgramDir(parentDir, name);
    return readProgramYaml(programDir, name);
  });
}
function loadProgramFromProgramsDir(root, name) {
  return __async(this, null, function* () {
    return loadProgramMeta(root, name);
  });
}
function loadProgram(root, name, options) {
  return __async(this, null, function* () {
    const programsDir = yield getProgramsDirReadOnly(root);
    const { onProgress } = options != null ? options : {};
    const programDir = yield resolveProgramDir(programsDir, name);
    const yamlHandle = yield programDir.getFileHandle("program.yaml");
    const yamlFile = yield yamlHandle.getFile();
    const programYaml = yield readProgramYaml(programDir, name);
    const wavFiles = [];
    let samplesDir;
    try {
      samplesDir = yield programDir.getDirectoryHandle("samples");
    } catch (e) {
      return { yaml: programYaml, wavFiles: [] };
    }
    const wavEntries = [];
    try {
      for (var iter = __forAwait(samplesDir.values()), more, temp, error; more = !(temp = yield iter.next()).done; more = false) {
        const entry = temp.value;
        if (entry.kind === "file" && entry.name.endsWith(".wav")) {
          const fileHandle = yield samplesDir.getFileHandle(entry.name);
          const file = yield fileHandle.getFile();
          wavEntries.push({ filename: entry.name, file });
        }
      }
    } catch (temp) {
      error = [temp];
    } finally {
      try {
        more && (temp = iter.return) && (yield temp.call(iter));
      } finally {
        if (error)
          throw error[0];
      }
    }
    const yamlSize = yamlFile.size;
    const wavTotalBytes = wavEntries.reduce((sum, e) => sum + e.file.size, 0);
    const totalBytes = yamlSize + wavTotalBytes;
    const totalSteps = 1 + wavEntries.length;
    onProgress == null ? void 0 : onProgress({
      currentStep: 1,
      totalSteps,
      stepLabel: `Loaded metadata: ${name}/program.yaml`,
      bytesSent: yamlSize,
      bytesTotal: yamlSize,
      bytesSentAllSteps: 0,
      bytesTotalAllSteps: totalBytes
    });
    let bytesSentPrior = yamlSize;
    for (let i = 0; i < wavEntries.length; i++) {
      const wavEntry = wavEntries[i];
      const step = i + 2;
      const wavBytes = wavEntry.file.size;
      onProgress == null ? void 0 : onProgress({
        currentStep: step,
        totalSteps,
        stepLabel: `Loading audio: ${name}/samples/${wavEntry.filename}`,
        bytesSent: 0,
        bytesTotal: wavBytes,
        bytesSentAllSteps: bytesSentPrior,
        bytesTotalAllSteps: totalBytes
      });
      const data = yield wavEntry.file.arrayBuffer();
      wavFiles.push({ filename: wavEntry.filename, data });
      bytesSentPrior += wavBytes;
      onProgress == null ? void 0 : onProgress({
        currentStep: step,
        totalSteps,
        stepLabel: `Loading audio: ${name}/samples/${wavEntry.filename}`,
        bytesSent: wavBytes,
        bytesTotal: wavBytes,
        bytesSentAllSteps: bytesSentPrior,
        bytesTotalAllSteps: totalBytes
      });
    }
    return { yaml: programYaml, wavFiles };
  });
}
function getProgramDirFromProgramsDir(root, name) {
  return __async(this, null, function* () {
    const programsDir = yield getProgramsDirReadOnly(root);
    return resolveProgramDir(programsDir, name);
  });
}
export {
  AdsrEnvelopeSchema,
  BaseWaveParamsSchema,
  BrowserLibraryConnection,
  CachedStorageDirectoryHandle,
  ChoppedSampleSchema,
  ConverterRegistry,
  DEFAULT_BASE_NOTE2 as DEFAULT_BASE_NOTE,
  DEFAULT_DRUM_TYPES2 as DEFAULT_DRUM_TYPES,
  DEFAULT_SEARCH_CONFIG,
  DEFAULT_SPLICE_CONFIG,
  DEFAULT_TRANSIENT_CONFIG,
  DeviceTypeSchema,
  DrumKitBundleSchema,
  DrumKitChoppedSampleSchema,
  DrumKitEntryBundleSchema,
  DrumKitEntrySchema,
  DrumKitMetadataSchema,
  DrumKitSamplesSchema,
  DrumKitTemplateSchema,
  GenericChoppedSampleSchema,
  HARDWARE_CONSTRAINTS,
  KeyGroupSchema,
  KeyRangeSchema,
  LIBRARY_CATEGORIES,
  LoopDetectionError,
  LoopModeSchema,
  MidiNoteNameSchema,
  MidiNoteSchema,
  OPFSLibraryConnection,
  PatchYamlSchema,
  PlaybackConfigSchema,
  PlaybackModeSchema,
  PolyphonyModeSchema,
  ProgramYamlSchema,
  S330AftertouchAssignSchema,
  S330EnvelopeSchema,
  S330KeyAssignSchema,
  S330KeyModeSchema,
  S330LfoParamsSchema,
  S330PatchExtensionSchema,
  S330ToneExtensionSchema,
  S330TvaParamsSchema,
  S330TvfParamsSchema,
  S550PatchExtensionSchema,
  S550ToneExtensionSchema,
  SampleYamlSchema,
  SetPatchEntrySchema,
  SetSystemParamsSchema,
  SetToneEntrySchema,
  SetYamlSchema,
  SliceDefinitionSchema,
  SourceInfoSchema,
  StorageCache,
  TemplateHandlerRegistry,
  TemplateTypeSchema,
  TemplateYamlSchema,
  ToneYamlSchema,
  TriggerMappingSchema,
  VelocityLayerEntrySchema,
  VelocityLayerTemplateSchema,
  VelocityRangeSchema,
  WaveSegmentAllocationSchema,
  ZoneSchema,
  amplitudeToDb,
  analyzeAttack,
  analyzeDiscontinuity,
  analyzeForSlicing2 as analyzeForSlicing,
  applyCrossfade,
  batchCalculateNCC,
  batchCalculateSpectralSimilarity,
  buildSampleYaml,
  calculateCompositeScore,
  calculateNCC,
  calculateOptimalCrossfadeLength,
  calculateOptimalFFTSize,
  calculateOptimalWindowSize,
  calculatePeak,
  calculateRms,
  calculateRmsWindowed,
  calculateSegmentsNeeded,
  calculateSetSegmentUsage,
  calculateSlopeScore,
  calculateSpectralDistance,
  calculateZeroMeanNCC,
  choppedSampleToDrumKitBundle,
  computeLogMagnitudeSpectrum,
  converterRegistry,
  copyDirectoryContents,
  createFolder,
  createGenericChoppedSample,
  createHannWindow,
  createPatchFromKeyGroups,
  createRegionsFromBoundaries,
  createRegionsFromTempo,
  createSmoothedCopy,
  createWav,
  dbToAmplitude,
  deduplicateCandidates,
  deleteItem,
  deriveSampleName,
  detectZeroCrossings,
  deviceStateToSet,
  drumKitBundleToChoppedSample,
  extractWavSampleRate,
  filterByPolarity,
  filterByThresholds,
  findMatchingCrossings,
  findOnsetAboveThreshold,
  findSilenceStart,
  findSustainStart,
  generateCandidatePairs,
  getAllSampleFilenames,
  getNestedDirectory,
  getNestedDirectoryIfExists,
  getProgramDirFromProgramsDir,
  importWavToCommonArea,
  isValidMoveTarget,
  listCommonProgramsTree,
  listCommonSamplesTree,
  listPatchesTree,
  listSetTonesTree,
  listSets,
  listTonesTree,
  loadChoppedSample,
  loadDrumKitBundle,
  loadProgram,
  loadProgramFromProgramsDir,
  loadProgramMeta,
  loadSample,
  loadSampleMeta,
  matchBySlope,
  midiNoteToName,
  migrateChoppedSample,
  moveDirectory,
  moveItem,
  msToSamples,
  normalizeNCCScore,
  normalizeSpectralDistance,
  parseDrumFilename,
  parseDrumKitDirectory,
  parseMidiNote,
  parseNoteName,
  parseWav,
  quickSearchLoopPoints,
  rankCandidates,
  readFileWithProgress,
  readTextWithProgress,
  refineOnsetPosition,
  resolveKey,
  resolveMidiNotes,
  s330PatchConverter,
  s330SamplePromotion,
  s330TemplateHandler,
  s330ToWav,
  s330ToneConverter,
  calculateSetSegmentUsage2 as s550CalculateSetSegmentUsage,
  createPatchFromKeyGroups2 as s550CreatePatchFromKeyGroups,
  deviceStateToSet2 as s550DeviceStateToSet,
  s550PatchConverter,
  s550SamplePromotion,
  setToDeviceState2 as s550SetToDeviceState,
  seriesToWav as s550ToWav,
  s550ToneConverter,
  validateSetAllocations2 as s550ValidateSetAllocations,
  samplesToMs,
  sanitizeForFilename,
  saveChoppedSample,
  saveProgram,
  saveSample,
  scanCommonSamplesDirectory,
  scanLibraryDirectory,
  scanPatchesDirectory,
  scanTonesDirectory,
  scoreCandidate,
  scoreCandidates,
  scoreSpectralSimilarity,
  search as searchLoop,
  searchLoopPoints,
  setToDeviceState,
  sliceAudio2 as sliceAudio,
  sliceByFixedInterval,
  sliceByManualRegions,
  sliceBySilence,
  sliceByTransient,
  slicesToDrumKit,
  snapToWordBoundary,
  templateHandlerRegistry,
  trimSilence,
  validateCandidate,
  validateSetAllocations,
  validateToneReferences,
  validateWaveDataFits,
  wavToS330,
  wavToSeries as wavToS550,
  withCache
};
//# sourceMappingURL=browser.js.map